<template>
  <div class="content_main">
    <a-tabs @change="callback">
      <a-tab-pane key="1" tab="物品清单">
        <div style="margin-top: 10px">
          <a-button v-if="assetsInputConsumables" type="primary" @click="Input">资产录入</a-button>
          <a-button v-if="assetsExportConsumables" type="primary" @click="exp"> 数据导出 </a-button>
          <!-- <a-button v-if="assetsUpdateMoneyConsumables" type="primary" @click="modification" :disabled="!hasSelected">
						批量修改金额
					</a-button> -->
        </div>
        <div class="content_main_top">
          <a-select show-search allowClear placeholder="公司名称" class="margin_self" @change="handlecompany"
            v-model="company_id" @keyup.enter.native="query" style="width: 200px">
            <a-select-option :value="item.deptId" v-for="(item, index) in companylist" :key="index">
              {{ item.title }}
            </a-select-option>
          </a-select>
          <a-tree-select allowClear :tree-data="deptList" placeholder="部门名称" :disabled="!this.company_id"
            style="width: 200px; margin-right: 5px" v-model="dept_id" @keyup.enter.native="query">
          </a-tree-select>
          <!-- <a-select show-search allowClear placeholder="部门名称" class="margin_self" :disabled="!this.company_id" 
						v-model="dept_id" @keyup.enter.native="query" style="width: 120px">
						<a-select-option :value="item.deptId" v-for="(item, index) in deptList" :key="index">
							{{ item.title }}
						</a-select-option>
					</a-select> -->
          <a-input v-model="category_name" allowClear class="a_input_self margin_self" placeholder="品类名称"
            @keyup.enter.native="query" />
          <a-select show-search allowClear placeholder="资产类别" class="margin_self" v-model="asset_type"
            style="width: 120px" @keyup.enter.native="query">
            <a-select-option :value="item.value" v-for="(item, index) in goodsType" :key="index">
              {{ item.label }}
            </a-select-option>
          </a-select>
          <a-input v-model="asset_sn" allowClear class="a_input_self margin_self" placeholder="物品编号"
            @keyup.enter.native="query" />
          <a-input v-model="name" allowClear class="a_input_self margin_self" placeholder="物品名称"
            @keyup.enter.native="query" />
          <a-select show-search allowClear placeholder="物品状态" class="margin_self" v-model="state" style="width: 120px"
            @keyup.enter.native="query">
            <a-select-option :value="index" v-for="(item, index) in statusMap7" :key="index">
              {{ item }}
            </a-select-option>
          </a-select>
          <a-input v-model="charger" allowClear class="margin_self" placeholder="责任人" style="width: 100px"
            @keyup.enter.native="query" />
          <a-input v-model="keeper" allowClear class="margin_self" placeholder="保管人" style="width: 100px"
            @keyup.enter.native="query" />
          <a-select show-search allowClear placeholder="标签打印" class="margin_self" v-model="is_labelled"
            style="width: 120px" @keyup.enter.native="query">
            <a-select-option :value="index" v-for="(item, index) in labelledMap" :key="index">
              {{ item }}
            </a-select-option>
          </a-select>
          <a-select show-search allowClear placeholder="图片上传" class="margin_self" v-model="has_pic" style="width: 120px"
            @keyup.enter.native="query">
            <a-select-option :value="index" v-for="(item, index) in imgMap" :key="index">
              {{ item }}
            </a-select-option>
          </a-select>
          <a-range-picker valueFormat="YYYY-MM-DD" style="margin-right: 10px; width: 220px" allowClear :value="dates"
            @change="onChange" :placeholder="['采购开始', '采购结束']" @keyup.enter.native="query" />
          <a-button type="primary" @click="query"> 查询 </a-button>
          <a-button type="primary" ghost @click="result"> 重置 </a-button>
        </div>
        <div class="content_main_center" id="content_main_center_scroll" style="height: calc(100% - 142px)">
          <a-table :columns="columns" :data-source="data" bordered :pagination="false"
            :scroll="{ x: 1500, y: scroll_y }">
            <span slot="index" slot-scope="text, record, index">
              {{ (current - 1) * pageSize + index + 1 }}
            </span>
            <span slot="asset_type" slot-scope="text">
              {{ text ? goodsTypeObj[text] : '' }}
            </span>
            <span slot="state" slot-scope="text">
              <template>
                <a-tag :color="colors[text]">
                  {{ text ? statusMap6[text] : '' }}
                </a-tag>
              </template>
            </span>
            <span slot="is_inspected" slot-scope="text">
              {{ instrumentMap[text] }}
            </span>
            <!-- <span slot="dept_id" slot-scope="text">
					{{ text ? deptMap[text].text : '' }}
				</span> -->
            <span slot="is_labelled" slot-scope="text" :style="{ color: text == 1 ? '#1890ff' : 'red' }">
              {{ text == 1 ? '已打印标签' : '未打印标签' }}
            </span>
            <span slot="img" slot-scope="text, record" :style="{ color: record.pic_path ? 'green' : 'red' }">
              {{ record.pic_path ? '已上传图片' : '未上传图片' }}
            </span>
            <span slot="action" slot-scope="text, record">
              <a v-if="assetsUpdateConsumables" @click="edit(record)">编辑</a>
              <a-divider v-if="assetsInfoConsumables" type="vertical" />
              <a v-if="assetsInfoConsumables" @click="details(record)">详情</a>
            </span>
          </a-table>
        </div>
        <div class="content_main_bot">
          <a-pagination v-model="current" show-size-changer :page-size.sync="pageSize" :total="total"
            @showSizeChange="showSizeChange" :pageSizeOptions="['10', '20', '30', '50']" @change="onShowSizeChange" />
        </div>
        <a-modal v-model="changevisible" title="批量修改金额">
          <template slot="footer">
            <a-button key="back" @click="moneyCancel"> 取消 </a-button>
            <a-button key="submit" type="primary" @click="moneyOk"> 保存 </a-button>
          </template>
          <a-table :data-source="selectedRow" bordered :pagination="false">
            <a-table-column key="name" title="物品名称" data-index="name" />
            <a-table-column key="model" title="规格型号" data-index="model" />
            <a-table-column key="asset_sn" title="物品编号" data-index="asset_sn" />
            <a-table-column key="value" title="当前估值" data-index="value">
              <template slot-scope="text, record">
                <a-input v-model="record.value" />
              </template>
            </a-table-column>
          </a-table>
        </a-modal>
        <!-- <<<<<<< HEAD -->
        <!-- </a-table-column>
			</a-table>
		</a-modal> -->
        <a-modal title="固定资产-详情" :visible="detailsvisible" @cancel="detailsCancel" width="880px">
          <template slot="footer">
            <a-button type="primary" @click="purchaseClick" v-if="detailsrow.order_id"> 采购信息 </a-button>
            <a-button type="primary" @click="scrappedClick" v-if='detailsrow.state == 6'> 报废详情 </a-button>
            <a-button key="back" @click="detailsOk"> 取消 </a-button>
          </template>
          <a-form-model :model="detailsrow" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-form-model-item label="资产类别" class="form_item">
              <span>{{ detailsrow.asset_type ? goodsTypeObj[detailsrow.asset_type] : '' }}</span>
            </a-form-model-item>
            <a-form-model-item label="品类名称" class="form_item">
              <span>{{ detailsrow.category_name }}</span>
            </a-form-model-item>
            <div v-if="detailsrow.asset_type === 53">
              <a-form-model-item label="仪器一级分类" class="form_item">
                <span>{{ detailsrow.device_type_name }}</span>
              </a-form-model-item>
              <a-form-model-item label="仪器二级分类" class="form_item">
                <span>{{ detailsrow.dict_key_name }}</span>
              </a-form-model-item>
            </div>
            <!-- <a-form-model-item label="物品编号" class="form_item">
              <span>{{ detailsrow.asset_sn }}</span>
            </a-form-model-item>
             <a-form-model-item label="物品编号" class="form_item">
              <span>{{ detailsrow.asset_sn }}</span>
            </a-form-model-item> -->
            <a-form-model-item label="物品编号" class="form_item">
              <span>{{ detailsrow.asset_sn }}</span>
            </a-form-model-item>
            <a-form-model-item label="物品名称" class="form_item">
              <span>{{ detailsrow.name }}</span>
            </a-form-model-item>
            <a-form-model-item label="物品单位" class="form_item">
              <span>{{ detailsrow.unit }}</span>
            </a-form-model-item>
            <a-form-model-item label="物品状态" class="form_item">
              <span>{{ detailsrow.state ? statusMap[detailsrow.state] : '' }}</span>
            </a-form-model-item>
            <a-form-model-item label="规格型号" class="form_item">
              <span>{{ detailsrow.model }}</span>
            </a-form-model-item>
            <a-form-model-item label="采购时间" class="form_item">
              <span>{{ detailsrow.purchase_time }}</span>
            </a-form-model-item>
            <a-form-model-item label="采购单价" class="form_item">
              <span>{{ detailsrow.purchase_price }}</span>
            </a-form-model-item>
            <a-form-model-item label="责任部门" class="form_item">
              <span>{{ detailsrow.dept_id ? deptMap[detailsrow.dept_id].title : '' }}</span>
            </a-form-model-item>
            <a-form-model-item label="当前估值" class="form_item">
              <span>{{ detailsrow.value }}</span>
            </a-form-model-item>
            <a-form-model-item label="责 任 人 " class="form_item">
              <span>{{ detailsrow.charger }}</span>
            </a-form-model-item>
            <a-form-model-item label="入 库 人 " class="form_item">
              <span>{{ detailsrow.operator }}</span>
            </a-form-model-item>
            <a-form-model-item label="保 管 人 " class="form_item">
              <span>{{ detailsrow.keeper }}</span>
            </a-form-model-item>
            <a-form-model-item label="到货日期" class="form_item">
              <span>{{ detailsrow.arrive_time }}</span>
            </a-form-model-item>
            <a-form-model-item label="存放位置" class="form_item">
              <span>{{ detailsrow.storage_loc }}</span>
            </a-form-model-item>
            <a-form-model-item label="作业条件" class="form_item">
              <span>{{ detailsrow.storage_cond }}</span>
            </a-form-model-item>
            <a-form-model-item label="供 应 商 " class="form_item">
              <span>{{ detailsrow.dealer }}</span>
            </a-form-model-item>
            <a-form-model-item label="生产厂家" class="form_item">
              <span>{{ detailsrow.manufacturer }}</span>
            </a-form-model-item>
            <a-form-model-item label="出厂编号" class="form_item">
              <span>{{ detailsrow.factory_sn }}</span>
            </a-form-model-item>
            <a-form-model-item label="是否检定" class="form_item">
              <span>{{ instrumentMap[detailsrow.is_inspected] }}</span>
            </a-form-model-item>
            <a-form-model-item label="检定周期" class="form_item">
              <span>{{ detailsrow.inspect_cycle }}</span>
            </a-form-model-item>
            <a-form-model-item label="检定日期" class="form_item">
              <span>{{ detailsrow.inspect_time }}</span>
            </a-form-model-item>
            <a-form-model-item label="仪器精度" class="form_item">
              <span>{{ detailsrow.precisions }}</span>
            </a-form-model-item>
            <a-form-model-item label="检定结果" class="form_item">
              <span>{{ detailsrow.inspect_result }}</span>
            </a-form-model-item>
            <a-form-model-item label="准用说明" class="form_item">
              <span>{{ detailsrow.permit }}</span>
            </a-form-model-item>
            <a-form-model-item label="录 入 人 " class="form_item">
              <span>{{ detailsrow.create_by }}</span>
            </a-form-model-item>
            <a-form-model-item label="录入时间" class="form_item">
              <span>{{ detailsrow.create_time }}</span>
            </a-form-model-item>
            <a-form-model-item label="维 护 人 " class="form_item">
              <span>{{ detailsrow.update_by }}</span>
            </a-form-model-item>
            <a-form-model-item label="维护时间" class="form_item">
              <span>{{ detailsrow.update_time }}</span>
            </a-form-model-item>
            <a-row>
              <a-col :span="12">
                <a-form-model-item label="备注信息">
                  <span>{{ detailsrow.notes }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="物品图片">
                  <div class="view_path_img" v-for="(item, index) in detailsrow.pic_path_list" :key="index"
                    style="display: flex; justify-content: space-between">
                    <div class="view_path_img_margin"></div>
                    <div class="view_path_img_center">
                      <img :src="item" @click="show_img(index, detailsrow.pic_path_list)" />
                    </div>
                  </div>
                  <!-- ======= -->

                  <!-- <a-modal title="固定资产-详情" :visible="detailsvisible" @cancel="detailsCancel" width="880px">
					<template slot="footer">
						<a-button type="primary" @click="purchaseClick"> 采购信息 </a-button>
						<a-button type="primary" @click="scrappedClick" v-if='detailsrow.state == 6'> 报废详情 </a-button>
						<a-button key="back" @click="detailsOk"> 取消 </a-button>
					</template>
					<a-form-model :model="detailsrow" :labelCol="labelCol" :wrapperCol="wrapperCol">
						<a-form-model-item label="资产类别" class="form_item">
							<span>{{ detailsrow.asset_type ? goodsTypeObj[detailsrow.asset_type] : '' }}</span>
>>>>>>> develop
						</a-form-model-item>
						<a-form-model-item label="品类名称" class="form_item">
							<span>{{ detailsrow.category_name }}</span>
						</a-form-model-item>
						<a-form-model-item label="物品编号" class="form_item">
							<span>{{ detailsrow.asset_sn }}</span>
						</a-form-model-item>
						<a-form-model-item label="物品名称" class="form_item">
							<span>{{ detailsrow.name }}</span>
						</a-form-model-item>
						<a-form-model-item label="物品单位" class="form_item">
							<span>{{ detailsrow.unit }}</span>
						</a-form-model-item>
						<a-form-model-item label="物品状态" class="form_item">
							<span>{{ detailsrow.state ? statusMap[detailsrow.state] : '' }}</span>
						</a-form-model-item>
						<a-form-model-item label="规格型号" class="form_item">
							<span>{{ detailsrow.model }}</span>
						</a-form-model-item>
						<a-form-model-item label="采购日期" class="form_item">
							<span>{{ detailsrow.purchase_time }}</span>
						</a-form-model-item>
						<a-form-model-item label="采购价格" class="form_item">
							<span>{{ detailsrow.purchase_price }}</span>
						</a-form-model-item>
						<a-form-model-item label="负责部门" class="form_item">
							<span>{{ detailsrow.dept_id ? deptMap[detailsrow.dept_id].text : '' }}</span>
						</a-form-model-item>
						<a-form-model-item label="当前估值" class="form_item">
							<span>{{ detailsrow.value }}</span>
						</a-form-model-item>
						<a-form-model-item label="责 任 人 " class="form_item">
							<span>{{ detailsrow.charger }}</span>
						</a-form-model-item>
						<a-form-model-item label="入 库 人 " class="form_item">
							<span>{{ detailsrow.operator }}</span>
						</a-form-model-item>
						<a-form-model-item label="保 管 人 " class="form_item">
							<span>{{ detailsrow.keeper }}</span>
						</a-form-model-item>
						<a-form-model-item label="到货日期" class="form_item">
							<span>{{ detailsrow.arrive_time }}</span>
						</a-form-model-item>
						<a-form-model-item label="存放位置" class="form_item">
							<span>{{ detailsrow.storage_loc }}</span>
						</a-form-model-item>
						<a-form-model-item label="作业条件" class="form_item">
							<span>{{ detailsrow.storage_cond }}</span>
						</a-form-model-item>
						<a-form-model-item label="供 应 商 " class="form_item">
							<span>{{ detailsrow.dealer }}</span>
						</a-form-model-item>
						<a-form-model-item label="生产厂家" class="form_item">
							<span>{{ detailsrow.manufacturer }}</span>
						</a-form-model-item>
						<a-form-model-item label="出厂编号" class="form_item">
							<span>{{ detailsrow.factory_sn }}</span>
						</a-form-model-item>
						<a-form-model-item label="是否检定" class="form_item">
							<span>{{ instrumentMap[detailsrow.is_inspected] }}</span>
						</a-form-model-item>
						<a-form-model-item label="检定周期" class="form_item">
							<span>{{ detailsrow.inspect_cycle }}</span>
						</a-form-model-item>
						<a-form-model-item label="检定日期" class="form_item">
							<span>{{ detailsrow.inspect_time }}</span>
						</a-form-model-item>
						<a-form-model-item label="仪器精度" class="form_item">
							<span>{{ detailsrow.precisions }}</span>
						</a-form-model-item>
						<a-form-model-item label="检定结果" class="form_item">
							<span>{{ detailsrow.inspect_result }}</span>
						</a-form-model-item>
						<a-form-model-item label="准用说明" class="form_item">
							<span>{{ detailsrow.permit }}</span>
						</a-form-model-item>
						<a-form-model-item label="录 入 人 " class="form_item">
							<span>{{ detailsrow.create_by }}</span>
						</a-form-model-item>
						<a-form-model-item label="录入时间" class="form_item">
							<span>{{ detailsrow.create_time }}</span>
						</a-form-model-item>
						<a-form-model-item label="维 护 人 " class="form_item">
							<span>{{ detailsrow.update_by }}</span>
						</a-form-model-item>
						<a-form-model-item label="维护时间" class="form_item">
							<span>{{ detailsrow.update_time }}</span>
						</a-form-model-item>
						<a-row>
							<a-col :span="12">
								<a-form-model-item label="备注信息" class="form_item">
									<span>{{ detailsrow.notes }}</span>
								</a-form-model-item>
							</a-col>
							<a-col :span="12">
								<a-form-model-item label="物品图片">
									<div class="view_path_img" v-for="(item, index) in detailsrow.pic_paths"
										:key="index" style="display: flex; justify-content: space-between">
										<div class="view_path_img_margin"></div>
										<div class="view_path_img_center">
											<img :src="pyapi_url + item"
												@click="show_img(index, detailsrow.pic_paths)" />
										</div>
									</div>-->
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item label="附件信息">
                  <div class="view_path" @click="previewFile(item)" v-for="(item, index) in detailsrow.att_paths"
                    :key="index">
                    {{ item.name }}
                  </div>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="证书信息">
                  <div class="view_path" @click="previewFile(item)" v-for="(item, index) in detailsrow.cert_paths"
                    :key="index">
                    {{ item.name }}
                  </div>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </a-modal>
        <a-modal title="固定资产-编辑" :visible="editvisible" @cancel="editCancel" width="880px" :maskClosable="false">
          <template slot="footer">
            <a-button key="back" @click="editCancel"> 取消 </a-button>
            <a-button type="primary" @click="editOk"> 保存 </a-button>
          </template>
          <a-form-model ref="ruleForm" :model="detailsrow" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-row>
              <a-col :span="12">
                <a-form-model-item label="资产类别">
                  <span>{{ detailsrow.asset_type ? goodsTypeObj[detailsrow.asset_type] : '' }}</span>
                  <!-- <a-select allowClear v-model="assets" placeholder="请选择">
								<a-select-option :key="index" v-for="(item, index) in assettype" :value="item.dictCode">
									{{ item.dictLabel }}
								</a-select-option>
							</a-select> -->
                  <!-- <<<<<<< HEAD -->
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="品类名称" prop="category_id" :rules="{
                  required: true,
                  message: '请选择品类名称',
                  trigger: 'change',
                }">
                  <a-select allowClear show-search :filter-option="filterOption" @change="changeCategoryName"
                    v-model="detailsrow.category_id" placeholder="请选择">
                    <a-select-option :key="index" v-for="(item, index) in nameList" :value="item.id">
                      {{ item.categoryName }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row v-if="detailsrow.asset_type === 53">
              <a-col :span="12">
                <a-form-model-item label="仪器一级分类">
                  <a-select allowClear :filter-option="filterOption" v-model="detailsrow.device_type" placeholder="请选择"
                    @change="getLabList" prop="deviceType" :rules="{
                      required: true,
                      message: '请选择仪器一级分类',
                      trigger: 'change',
                    }">
                    <a-select-option :key="index" v-for="(item, index) in dictList" :value="item.dictValue">
                      {{ item.remark }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="仪器二级分类">
                  <a-select allowClear :filter-option="filterOption" v-model="detailsrow.dict_key" placeholder="请选择"
                    :disabled="labList.length < 0" prop="dictkey" :rules="{
                      required: true,
                      message: '请选择仪器二级分类',
                      trigger: 'change',
                    }">
                    <a-select-option :key="index" v-for="(item, index) in labList" :value="item.dictValue">
                      {{ item.dictLabel }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item label="物品编号">
                  <span>{{ detailsrow.asset_sn }}</span>
                </a-form-model-item>
              </a-col>

              <a-col :span="12">
                <a-form-model-item label="物品名称">
                  <span>{{ detailsrow.name }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <!-- <a-row>
					<a-col :span="12">
						<a-form-model-item label="物品单位">
							<a-input allowClear v-model="detailsrow.unit" placeholder="请输入" />
						</a-form-model-item>
					</a-col>
				
					<a-col :span="12">
						<a-form-model-item label="物品状态">
							<a-select allowClear v-model="detailsrow.state" placeholder="请选择" @change="changeData">
								<a-select-option :key="index" v-for="(item, index) in statusMap6" :value="index">
									{{ item }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="规格型号" ref="model" prop="model">
							<span>{{detailsrow.model}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="采购时间">
							<span>{{detailsrow.purchase_time}}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="采购价格">
							<span>{{detailsrow.purchase_price}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="责任部门" ref="dept_id" prop="dept_id"> -->
            <!-- <span>{{detailsrow.dept_name}}</span> -->
            <!-- <a-tree-select :treeData="deptTree" placeholder="负责部门" v-model="detailsrow.dept_id"
								treeDefaultExpandAll>
							</a-tree-select>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="当前估值">
							<a-input allowClear type="number" v-model="detailsrow.value" placeholder="请输入" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="责 任 人 " ref="charger">
							<a-input allowClear v-model="detailsrow.charger" placeholder="请输入" /> -->
            <!-- <span>{{detailsrow.charger}}</span> -->
            <!-- </a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="入 库 人 ">
							<span>{{detailsrow.operator}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="保 管 人 ">
							<a-input allowClear v-model="detailsrow.keeper" placeholder="请输入" /> -->
            <!-- <span>{{detailsrow.keeper}}</span> -->
            <!-- </a-form-model-item>
					</a-col>
				</a-row> -->
            <!-- <a-row>
					<a-col :span="12">
						<a-form-model-item label="到货日期">
							<span>{{detailsrow.arrive_time}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="存放位置">
							<a-input allowClear v-model="detailsrow.storage_loc" placeholder="请输入" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="作业条件">
							<a-input allowClear v-model="detailsrow.storage_cond" placeholder="请输入" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="供 应 商 ">
							<a-input allowClear v-model="detailsrow.dealer" placeholder="请输入" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="生产厂家">
							<a-input allowClear v-model="detailsrow.manufacturer" placeholder="请输入" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="出厂编号">
							<a-input allowClear v-model="detailsrow.factory_sn" placeholder="请输入" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="是否检定">
							<a-select v-model="isinstrument" placeholder="请选择">
								<a-select-option :key="index" v-for="(item, index) in instrumentMap" :value="index">
									{{ item }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="检定周期">
							<a-input allowClear v-model="detailsrow.inspect_cycle" placeholder="请输入" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="检定日期">
							<a-date-picker valueFormat="YYYY-MM-DD" :disabled-date="disabledDate" allowClear
								v-model="detailsrow.inspect_time" placeholder="请输入" style="width: 312px" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="仪器精度">
							<a-input allowClear v-model="detailsrow.precisions" placeholder="请输入" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="检定结果">
							<a-input allowClear v-model="detailsrow.inspect_result" placeholder="请输入" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="准用说明">
							<a-input allowClear v-model="detailsrow.permit" placeholder="请输入" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="录 入 人 ">
							<span>{{detailsrow.create_by}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="录入时间">
							<span>{{detailsrow.create_time}}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="维 护 人 ">
							<span>{{detailsrow.update_by}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="维护时间">
							<span>{{detailsrow.update_time}}</span>
						</a-form-model-item>
					</a-col>
				</a-row> -->
            <!-- =======
								</a-form-model-item>
							</a-col>
							<a-col :span="12">
								<a-form-model-item label="品类名称" prop="category_id" :rules="{
									required: true,
									message: '请选择品类名称',
									trigger: 'change',
								}">
									<a-select allowClear show-search :filter-option="filterOption"
										@change="changeCategoryName" v-model="detailsrow.category_id" placeholder="请选择">
										<a-select-option :key="index" v-for="(item, index) in nameList"
											:value="item.id">
											{{ item.categoryName }}
										</a-select-option>
									</a-select>
								</a-form-model-item>
							</a-col>
						</a-row> -->
            <!-- <a-row>
							<a-col :span="12">
								<a-form-model-item label="物品编号">
									<span>{{ detailsrow.asset_sn }}</span>
								</a-form-model-item>
							</a-col>

							<a-col :span="12">
								<a-form-model-item label="物品名称">
									<span>{{ detailsrow.name }}</span>
								</a-form-model-item>
							</a-col>
						</a-row> -->
            <a-row>
              <a-col :span="12">
                <a-form-model-item label="物品单位" prop="unit" :rules="{
                  required: true,
                  message: '请填写物品单位',
                  trigger: 'change',
                }">
                  <a-input allowClear v-model="detailsrow.unit" placeholder="请输入" />
                </a-form-model-item>
              </a-col>

              <a-col :span="12">
                <a-form-model-item label="物品状态" prop="state" :rules="{
                  required: true,
                  message: '请选择物品状态',
                  trigger: 'change',
                }">
                  <a-select allowClear v-model="detailsrow.state" placeholder="请选择" :disabled="detailsrow.state == 6">
                    <a-select-option :value="Number(index)" v-for="(item, index) in statusMap6" :key="index"
                      :disabled="index == 1 || index == 9 || index == 10 || index == 6">
                      {{ item }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item label="规格型号" ref="model" prop="model">
                  <span>{{ detailsrow.model }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="采购时间">
                  <span>{{ detailsrow.purchase_time }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item label="采购单价">
                  <span>{{ detailsrow.purchase_price }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="责任部门" ref="dept_id" prop="dept_id">
                  <!-- <span>{{detailsrow.dept_name}}</span> -->
                  <a-tree-select disabled :treeData="deptTree" placeholder="负责部门" v-model="detailsrow.dept_id"
                    treeDefaultExpandAll>
                  </a-tree-select>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item label="当前估值">
                  <a-input allowClear type="number" v-model="detailsrow.value" placeholder="请输入" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="责 任 人 " ref="charger">
                  <a-input allowClear v-model="detailsrow.charger" placeholder="请输入" disabled />
                  <!-- <span>{{detailsrow.charger}}</span> -->
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item label="入 库 人 ">
                  <span>{{ detailsrow.operator }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="保 管 人 ">
                  <a-input allowClear v-model="detailsrow.keeper" placeholder="请输入" disabled />
                  <!-- <span>{{detailsrow.keeper}}</span> -->
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item label="到货日期">
                  <span>{{ detailsrow.arrive_time }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="存放位置">
                  <a-input allowClear v-model="detailsrow.storage_loc" placeholder="请输入" />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item label="作业条件">
                  <a-input allowClear v-model="detailsrow.storage_cond" placeholder="请输入" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="供 应 商 ">
                  <a-input allowClear v-model="detailsrow.dealer" placeholder="请输入" />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item label="生产厂家">
                  <a-input allowClear v-model="detailsrow.manufacturer" placeholder="请输入" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="出厂编号">
                  <a-input allowClear v-model="detailsrow.factory_sn" placeholder="请输入" />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item label="是否检定">
                  <a-select v-model="detailsrow.is_inspected" placeholder="请选择">
                    <a-select-option :key="index" v-for="(item, index) in instrumentMap" :value="index">
                      {{ item }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="检定周期">
                  <a-input allowClear v-model="detailsrow.inspect_cycle" placeholder="请输入" />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item label="检定日期">
                  <a-date-picker valueFormat="YYYY-MM-DD" :disabled-date="disabledDate" allowClear
                    v-model="detailsrow.inspect_time" placeholder="请输入" style="width: 312px" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="仪器精度">
                  <a-input allowClear v-model="detailsrow.precisions" placeholder="请输入" />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item label="检定结果">
                  <a-input allowClear v-model="detailsrow.inspect_result" placeholder="请输入" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="准用说明">
                  <a-input allowClear v-model="detailsrow.permit" placeholder="请输入" />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item label="录 入 人 ">
                  <span>{{ detailsrow.create_by }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="录入时间">
                  <span>{{ detailsrow.create_time }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item label="维 护 人 ">
                  <span>{{ detailsrow.update_by }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="维护时间">
                  <span>{{ detailsrow.update_time }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item label="备注信息">
                  <a-input allowClear v-model="detailsrow.notes" placeholder="请输入" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="物品图片">
                  <div class="view_path_img" v-for="(item, index) in detailsrow.pic_path_list" :key="index"
                    style="display: flex; justify-content: space-between">
                    <div class="view_path_img_margin"></div>
                    <div class="view_path_img_center">
                      <img :src="item" @click="show_img(index, detailsrow.pic_path_list)" />
                    </div>
                  </div>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item label="附件信息">
                  <a-upload :action="preUrl" :headers="headers" name="file" :defaultFileList="defaultFileList"
                    v-if="detailsrow.asset_sn && detailsrow.dept_id && is_uplaod2" :remove="removeFile"
                    @preview="previewFile" :data="{
                      type: 'asset',
                      fileName: detailsrow.file_name,
                      assetSn: detailsrow.asset_sn,
                      deptId: detailsrow.dept_id,
                    }" method="post" :beforeUpload="beforeUpload" @change="handleChange">
                    <a-button>
                      <a-icon type="upload" /> 上传文件
                    </a-button>
                  </a-upload>
                  <el-row>
                    <div style="font-size: 13px; color: red">仅支持pdf文件上传(﹤=10MB)</div>
                  </el-row>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="证书信息">
                  <a-upload :action="preUrl" :headers="headers" name="file" :defaultFileList="defaultFileList2"
                    v-if="detailsrow.asset_sn && detailsrow.dept_id && is_uplaod3" :remove="removeFile2"
                    @preview="previewFile" :data="{
                      type: 'asset',
                      fileName: detailsrow.file_name2,
                      assetSn: detailsrow.asset_sn,
                      deptId: detailsrow.dept_id,
                    }" method="post" :beforeUpload="beforeUpload2" @change="handleChange2">
                    <a-button>
                      <a-icon type="upload" /> 上传文件
                    </a-button>
                  </a-upload>
                  <el-row>
                    <div style="font-size: 13px; color: red">仅支持pdf文件上传(﹤=10MB)</div>
                  </el-row>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </a-modal>
        <a-modal title="详情" :visible="Warehousingvisible" @cancel="WarehousingCancel" width="880px">
          <template slot="footer">
            <a-button type="primary" @click="WarehousingOk"> 确定 </a-button>
          </template>
          <a-form-model :model="Warehousingrow" style="height: 500px">
            <a-form-model-item label="资产类别" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
              <span>{{ Warehousingrow.asset_type ? operTypeMap[Warehousingrow.asset_type].text : '' }}</span>
            </a-form-model-item>
            <a-form-model-item label="物品状态" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
              <span>{{ Warehousingrow.state ? statusMap[Warehousingrow.state] : '' }}</span>
            </a-form-model-item>
            <a-form-model-item label="物品名称" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
              <span>{{ Warehousingrow.asset }}</span>
            </a-form-model-item>
            <a-form-model-item label="采购时间" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
              <span>{{ Warehousingrow.purchase_time }}</span>
            </a-form-model-item>
            <!-- <a-form-model-item label="是否仪器" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ Warehousingrow.is_instrument == null ? '' : instrumentMap[Warehousingrow.is_instrument] }}</span>
				</a-form-model-item> -->
            <a-form-model-item label="采购单价" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
              <span>{{ Warehousingrow.purchase_price }}</span>
            </a-form-model-item>
            <a-form-model-item label="物品编号" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
              <span>{{ Warehousingrow.asset_sn }}</span>
            </a-form-model-item>
            <a-form-model-item label="供 应 商 " :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
              <span>{{ Warehousingrow.dealer }}</span>
            </a-form-model-item>
            <a-form-model-item label="规格型号" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
              <span>{{ Warehousingrow.model }}</span>
            </a-form-model-item>
            <a-form-model-item label="负责部门" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
              <span>{{ Warehousingrow.dept_id ? deptMap[Warehousingrow.dept_id].title : '' }}</span>
            </a-form-model-item>
            <a-form-model-item label="责 任 人 " :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
              <span>{{ Warehousingrow.charger }}</span>
            </a-form-model-item>
            <a-form-model-item label="物品数量" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
              <span>{{ Warehousingrow.amount }}</span>
            </a-form-model-item>
            <a-form-model-item label="入 库 人 " :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
              <span>{{ Warehousingrow.operator }}</span>
            </a-form-model-item>
            <a-form-model-item label="准用说明" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
              <span>{{ Warehousingrow.permit }}</span>
            </a-form-model-item>
            <a-form-model-item label="保 管 人 " :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
              <span>{{ Warehousingrow.keeper }}</span>
            </a-form-model-item>
            <a-form-model-item label="最后检定时间" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
              <span>{{ Warehousingrow.inspect_time }}</span>
            </a-form-model-item>
            <a-form-model-item label="检定结果" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
              <span>{{ Warehousingrow.inspect_result }}</span>
            </a-form-model-item>
            <a-form-model-item label="精度" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
              <span>{{ Warehousingrow.precisions }}</span>
            </a-form-model-item>
          </a-form-model>
        </a-modal>
        <a-modal title="固定资产-录入" v-model="visible2" @ok="preservation2" @cancel="handleCancel2" width="880px"
          :maskClosable="false">
          <template slot="footer">
            <a-button key="back" @click="handleCancel2"> 取消 </a-button>
            <a-button key="submit" type="primary" @click="preservation2"> 保存 </a-button>
          </template>
          <a-form :form="form2" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-row>
              <a-col :span="12">
                <a-form-item label="资产类别">
                  <a-select allowClear
                    v-decorator="['asset_type', { rules: [{ required: true, message: '请选择资产类别!' }] }]" placeholder="请选择"
                    @change="changeAsset($event)">
                    <a-select-option :key="index" v-for="(item, index) in goodsType" :value="item.value">
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="品类名称">
                  <a-select allowClear show-search :filter-option="filterOption" @change="changeCategoryName1"
                    v-decorator="['category_id', { rules: [{ required: true, message: '请选择品类名称!' }] }]"
                    placeholder="请选择">
                    <a-select-option :key="index" v-for="(item, index) in nameList" :value="item.id">
                      {{ item.categoryName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row v-if="classify">
              <a-col :span="12">
                <a-form-item label="仪器一级分类">
                  <a-select allowClear :filter-option="filterOption"
                    v-decorator="['deviceType', { rules: [{ required: true, message: '请选择仪器一级分类!' }] }]"
                    placeholder="请选择" @change="getLabList">
                    <a-select-option :key="index" v-for="(item, index) in dictList" :value="item.dictValue">
                      {{ item.remark }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="仪器二级分类">
                  <a-select allowClear :filter-option="filterOption"
                    v-decorator="['dictkey', { rules: [{ required: true, message: '请选择仪器二级分类' }] }]" placeholder="请选择"
                    :disabled="!deviceId">
                    <a-select-option :key="index" v-for="(item, index) in labList" :value="item.dictValue">
                      {{ item.dictLabel }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-item label="物品编号">
                  <a-input allowClear v-decorator="['asset_sn', { rules: [{ required: true, message: '请填写物品编号!' }] }]"
                    placeholder="请输入" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="物品名称">
                  <a-input allowClear v-decorator="['name', { rules: [{ required: true, message: '请填写物品名称!' }] }]"
                    placeholder="请输入" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-item label="物品单位">
                  <a-input allowClear v-decorator="['unit', { rules: [{ required: true, message: '请输入单位!' }] }]"
                    placeholder="请输入" />
                </a-form-item>
              </a-col>

              <a-col :span="12">
                <a-form-item label="物品状态">
                  <a-select allowClear v-decorator="['state', { rules: [{ required: true, message: '请选择状态!' }] }]"
                    placeholder="请选择" @change="statechange">
                    <a-select-option :key="index" v-for="(item, index) in statusMap6" :value="index"
                      :disabled="index == 6 || index == 9">
                      {{ item }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-item label="规格型号">
                  <a-input allowClear v-decorator="['model', { rules: [{ required: true, message: '请填写规格型号!' }] }]"
                    placeholder="请输入" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="采购日期">
                  <a-date-picker valueFormat="YYYY-MM-DD" :disabled-date="disabledDate" allowClear
                    v-decorator="['purchase_time', { rules: [{ required: true, message: '请选择采购时间!' }] }]"
                    placeholder="请输入" style="width: 312px" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-item label="采购单价">
                  <a-input @blur="changevalue" type="number" allowClear
                    v-decorator="['purchase_price', { rules: [{ required: true, message: '请输入采购价格!' }] }]"
                    placeholder="请输入" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="责任部门">
                  <a-tree-select :treeData="deptTree" placeholder="请输入"
                    v-decorator="['dept_id', { rules: [{ required: true, message: '请选择责任部门!' }] }]" treeDefaultExpandAll
                    @change="leaderid($event)">
                  </a-tree-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-item label="当前估值">
                  <a-input allowClear type="number" v-decorator="['value']" placeholder="请输入" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="责 任 人 ">
                  <a-input allowClear v-decorator="['charger', { rules: [{ required: true, message: '请输入责任人!' }] }]"
                    placeholder="请输入" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-item label="入 库 人 ">
                  <a-input allowClear v-decorator="['operator']" placeholder="请输入" disabled />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="保 管 人 ">
                  <a-select show-search allowClear placeholder="请输入" class="margin_self"
                    v-decorator="['keeper', { rules: [{ required: true, message: '请输入保管人!' }] }]">
                    <a-select-option :value="item.userName" v-for="(item, index) in plainOptions" :key="index">
                      {{ item.userName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-item label="到货日期">
                  <a-date-picker valueFormat="YYYY-MM-DD" :disabled-date="disabledDate" allowClear
                    v-decorator="['arrive_time']" placeholder="请输入" style="width: 312px" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="存放位置">
                  <a-input allowClear v-decorator="['storage_loc']" placeholder="请输入" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-item label="作业条件">
                  <a-input allowClear v-decorator="['storage_cond']" placeholder="请输入" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="供 应 商 ">
                  <a-input allowClear v-decorator="['dealer']" placeholder="请输入" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-item label="生产厂家">
                  <a-input allowClear v-decorator="['manufacturer']" placeholder="请输入" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="出厂编号">
                  <a-input allowClear v-decorator="['factory_sn']" placeholder="请输入" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-item label="是否已检定">
                  <a-select allowClear v-decorator="['is_inspected']" placeholder="请选择">
                    <a-select-option :key="index" v-for="(item, index) in instrumentMap" :value="index">
                      {{ item }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="检定周期">
                  <a-input allowClear v-decorator="['inspect_cycle']" placeholder="请输入" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-item label="检定日期">
                  <a-date-picker valueFormat="YYYY-MM-DD" :disabled-date="disabledDate" allowClear
                    v-decorator="['inspect_time']" placeholder="请输入" style="width: 312px" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="仪器精度">
                  <a-input allowClear v-decorator="['precisions']" placeholder="请输入" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-item label="检定结果">
                  <a-input allowClear v-decorator="['inspect_result']" placeholder="请输入" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="准用说明">
                  <a-input allowClear v-decorator="['permit']" placeholder="请输入" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-item label="备注信息">
                  <a-input allowClear v-decorator="['notes']" placeholder="请输入" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-item label="上传附件">
                  <a-upload v-if="form2.getFieldValue('asset_sn') && form2.getFieldValue('dept_id') && is_uplaod"
                    :action="preUrl" :headers="headers" name="file" :remove="removeFile"
                    :default-file-list="defaultFileList" @preview="previewFile" :data="{
                      type: 'asset',
                      fileName: file_name,
                      assetSn: form2.getFieldValue('asset_sn'),
                      deptId: form2.getFieldValue('dept_id'),
                    }" method="post" :beforeUpload="beforeUpload" @change="handleChange">
                    <a-button>
                      <a-icon type="upload" /> 上传文件
                    </a-button>
                  </a-upload>
                  <el-row>
                    <div style="font-size: 13px; color: red">仅支持pdf文件上传(﹤=10MB)</div>
                  </el-row>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="上传证书">
                  <a-upload :action="preUrl" :headers="headers" name="file" :defaultFileList="defaultFileList2"
                    v-if="form2.getFieldValue('asset_sn') && form2.getFieldValue('dept_id') && is_uplaod4"
                    :remove="removeFile2" @preview="previewFile" :data="{
                      type: 'asset',
                      fileName: file_name2,
                      assetSn: form2.getFieldValue('asset_sn'),
                      deptId: form2.getFieldValue('dept_id'),
                    }" method="post" :beforeUpload="beforeUpload2" @change="handleChange2">
                    <a-button>
                      <a-icon type="upload" /> 上传文件
                    </a-button>
                  </a-upload>
                  <el-row>
                    <div style="font-size: 13px; color: red">仅支持pdf文件上传(﹤=10MB)</div>
                  </el-row>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </a-modal>
        <preview ref="preview" />
        <a-modal title="固定资产-报废信息" :visible="is_scrapped" @cancel="cancelScrapped" width="880px">
          <a-form :form="scrapData.info" v-if="scrapData" class="itemForm">
            <div class="title">
              <span>审批信息</span>
            </div>
            <div class="content">
              <a-row>
                <a-col :span="24">
                  <a-form-model-item label="审批标题" class="model_span_form" :label-col="{ span: 3 }"
                    :wrapper-col="{ span: 21 }">
                    <span>{{ scrapData.info.title }}</span>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="24">
                  <a-form-item label="审批编号" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                    <span class="spanClass">{{ scrapData.info.applyCode }}</span>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="24">
                  <a-form-item label="抄 送 人 " :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                    <span class="spanClass">{{ scrapData.info.ccName }}</span>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="8">
                  <a-form-item label="标　　题" class="model_span_form" :label-col="{ span: 9 }"
                    :wrapper-col="{ span: 15 }">
                    <span class="spanClass">{{ scrapData.info.title }}</span>
                  </a-form-item>
                </a-col>

              </a-row>
              <a-row>
                <a-col :span="24">
                  <a-form-item label="申请编号" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                    <span class="spanClass">{{ scrapData.info.applyCode }}</span>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="24">
                  <a-form-item label="报废原因" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                    <span class="spanClass">{{ scrapData.info.remark }}</span>
                  </a-form-item>
                </a-col>
              </a-row>
            </div>
            <div class="title">
              <span class="spanClass">物品信息</span>
            </div>
            <div class="content">
              <a-row>
                <a-col :span="8">
                  <a-form-item label="物品名称" :labelCol="labelCol3" :wrapperCol="wrapperCol3">
                    <span class="spanClass">{{ scrapData.info.asset.name }}</span>
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-form-item label="物品编号" :labelCol="labelCol3" :wrapperCol="wrapperCol3">
                    <span class="spanClass">{{ scrapData.info.asset.assetSn }}</span>
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-form-item label="型号规格" :labelCol="labelCol3" :wrapperCol="wrapperCol3">
                    <span class="spanClass">{{ scrapData.info.asset.model }}</span>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>

                <a-col :span="8">
                  <a-form-item label="采购时间" :labelCol="labelCol3" :wrapperCol="wrapperCol3">
                    <span class="spanClass">{{ scrapData.info.asset.purchaseTime }}</span>
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-form-item label="采购价格" :labelCol="labelCol3" :wrapperCol="wrapperCol3">
                    <span class="spanClass">{{ scrapData.info.asset.purchasePrice / 100 }}</span>
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-form-item label="保 管 人 " :labelCol="labelCol3" :wrapperCol="wrapperCol3">
                    <span class="spanClass">{{ scrapData.info.asset.keeper }}</span>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="8">
                  <a-form-item label="责任部门" :labelCol="labelCol3" :wrapperCol="wrapperCol3">
                    <span class="spanClass">{{ scrapData.info.asset.deptId ?
                        deptMap[scrapData.info.asset.deptId].text :
                        ''
                    
                    }}</span>
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-form-item label="责 任 人 " :labelCol="labelCol3" :wrapperCol="wrapperCol3">
                    <span class="spanClass">{{ scrapData.info.asset.charger }}</span>
                  </a-form-item>
                </a-col>
              </a-row>
            </div>
            <div class="title">
              <span>审批记录</span>
            </div>
            <div class="content">
              <a-table ref="table" rowKey="id" style="width:100%" :columns="scrapcolumns"
                :dataSource="scrapData.history.history">
                <span slot="serial" slot-scope="text, record, index">
                  {{ index + 1 }}
                </span>
                <span slot="auditor" slot-scope="text">
                  {{ text ? text.substr(0, text.indexOf('-')) : '' }}
                </span>
                <span slot="result" slot-scope="text" class="tag_class"
                  :style="{ background: text ? result_apply[text].color : 'orange' }">
                  {{ text | resultFilter }}
                </span>
              </a-table>
            </div>
            <div class="title">
              <span>审批流程</span>
            </div>
            <div class="content">
              <div class="stpe_box">
                <div class="stpe_item" v-for="(item, index) in stpesScrpd" :key="index">
                  <div class="center">
                    <div class="center_val" :style="{ background: item.flag ? color : '' }">
                      <div class="item" :style="{ color: item.flag ? '#fff' : '' }">{{ item.name
                      }}</div>
                      <div class="item minItem" :style="{ color: item.flag ? '#fff' : '' }">
                        <div class="auditor" v-for="(item1, index ) in item.auditorRrr" :key="index">{{ item1 }}</div>
                      </div>
                      <div class="item minItem" :style="{ color: item.flag ? '#fff' : '' }">{{
                          item.endTime
                      }}</div>
                      <div class="records" v-for="(user, idx) in item.records" :key="idx">
                        <div class="recordsTop" :style="{ color: item.flag ? '#fff' : '' }">
                          {{ user.source }}转交至{{ user.target }}
                        </div>
                        <div class="recordsTop" :style="{ color: item.flag ? '#fff' : '' }">{{
                            user.createTime
                        }}</div>
                        <div class="recordsTop" :style="{ color: item.flag ? '#fff' : '' }">{{
                            user.reason
                        }}</div>
                      </div>
                      <div class="item" v-if="item.duration" :style="{ color: item.flag ? '#fff' : '' }">本次审批共耗时：{{
                          item.duration
                      }}
                      </div>
                    </div>
                  </div>
                  <div class="stepRound" :style="{ background: item.flag ? color : '' }"></div>
                  <div class="stepLine" :style="{ background: item.flag ? color : '' }"
                    v-if="index != stpesScrpd.length - 1"></div>
                </div>
              </div>
              <div v-if="scrapData.history.commentList.length">
                <div>
                  <div style="font-weight: 600;font-size: 16px;margin-bottom: 10px;">
                    流程评论
                  </div>

                  <div v-for="(item) in scrapData.history.commentList" :key="item"
                    style="border-bottom: 1px solid #e8e8e8;padding:20px;width: 100%;height:100%;">
                    <div style="display: flex;justify-content: space-between;">
                      <div style="font-weight: 600;font-size: 16px;">
                        {{ item.userName }}
                      </div>
                      <div>
                        {{ item.createTime }}
                      </div>
                    </div>
                    <div style="margin-top: 10px;display: flex;justify-content: space-between;">
                      <div v-html="item.comment.replace(/\n/g, '<br/>')"
                        :style="{ color: (item.delFlag == 0 ? 'black' : 'lightgray') }">
                      </div>
                      <div style="color: #99ADDF;cursor:pointer" @click="withdraw(item)"
                        v-if="item.delFlag == 0 && item.userId == $store.getters.userInfo.userId">
                        撤回
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </a-form>
        </a-modal>
        <a-modal title="固定资产-采购信息" :visible="is_purchase" @cancel="cancelPurchase" width="80%">
          <div class="title">
            <span>采购详情</span>
          </div>
          <div class="content" v-if="purchaseData">
            <a-form :form="purchaseData.purchase" class="itemForm">
              <a-row>
                <a-col :span="12">
                  <a-form-model-item label="申请单号" class="model_span_form" :label-col="{ span: 4 }"
                    :wrapper-col="{ span: 20 }">
                    <span>{{ purchaseData.purchase.purchaseCode }}</span>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item label="申请标题" class="model_span_form" :label-col="{ span: 4 }"
                    :wrapper-col="{ span: 20 }">
                    <span>{{ purchaseData.purchase.title }}</span>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="12">
                  <a-form-model-item label="申请部门" class="model_span_form" :label-col="{ span: 4 }"
                    :wrapper-col="{ span: 20 }">
                    <span>{{ purchaseData.purchase.deptFullName }}</span>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item label="申请人" class="model_span_form" :label-col="{ span: 4 }"
                    :wrapper-col="{ span: 20 }">
                    <span>{{ purchaseData.business.applyer }}</span>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="12">
                  <a-form-model-item label="物品名称" class="model_span_form" :label-col="{ span: 4 }"
                    :wrapper-col="{ span: 20 }">
                    <span>{{ detailsrow.name }}</span>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item label="物品类型" class="model_span_form" :label-col="{ span: 4 }"
                    :wrapper-col="{ span: 20 }">
                    <span>{{ goodsTypeObj[purchaseData.purchase.itemType] }}</span>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="12">
                  <a-form-model-item label="规格型号" class="model_span_form" :label-col="{ span: 4 }"
                    :wrapper-col="{ span: 20 }">
                    <span>{{ detailsrow.model }}</span>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item label="申购数量" class="model_span_form" :label-col="{ span: 4 }"
                    :wrapper-col="{ span: 20 }">
                    <span>{{ purchaseData.purchase.bizGoodsInfos[0].amount }}</span>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="12">
                  <a-form-model-item label="单位" class="model_span_form" :label-col="{ span: 4 }"
                    :wrapper-col="{ span: 20 }">
                    <span>{{ detailsrow.unit }}</span>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item label="供应商报价均价" class="model_span_form" :label-col="{ span: 4 }"
                    :wrapper-col="{ span: 20 }">
                    <span>{{ purchaseData.purchase.bizGoodsInfos[0].averageQuote }}</span>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="12">
                  <a-form-model-item label="申请时间" class="model_span_form" :label-col="{ span: 4 }"
                    :wrapper-col="{ span: 20 }">
                    <span>{{ purchaseData.purchase.createTime }}</span>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item label="期望交付时间" class="model_span_form" :label-col="{ span: 4 }"
                    :wrapper-col="{ span: 20 }">
                    <span>{{ purchaseData.purchase.expectDate }}</span>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="12">
                  <a-form-model-item label="备注" class="model_span_form" :label-col="{ span: 4 }"
                    :wrapper-col="{ span: 20 }">
                    <span>{{ purchaseData.purchase.bizGoodsInfos[0].remark }}</span>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item label="使用部门" class="model_span_form" :label-col="{ span: 4 }"
                    :wrapper-col="{ span: 20 }">
                    <span>{{ purchaseData.purchase.bizGoodsInfos[0].usagesName }}</span>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="12">
                  <a-form-model-item label="采购价" class="model_span_form" :label-col="{ span: 4 }"
                    :wrapper-col="{ span: 20 }">
                    <span>{{ purchaseData.purchase.bizGoodsInfos[0].purchasePrice }}</span>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item label="供应商" class="model_span_form" :label-col="{ span: 4 }"
                    :wrapper-col="{ span: 20 }">
                    <span>{{ purchaseData.purchase.bizGoodsInfos[0].supplier }}</span>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="12">
                  <a-form-model-item label="采购人" class="model_span_form" :label-col="{ span: 4 }"
                    :wrapper-col="{ span: 20 }">
                    <span>{{ purchaseData.purchase.bizGoodsInfos[0].purchaser }}</span>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item label="采购时间" class="model_span_form" :label-col="{ span: 4 }"
                    :wrapper-col="{ span: 20 }">
                    <span>{{ purchaseData.purchase.bizGoodsInfos[0].purchaseTime }}</span>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="12">
                  <a-form-model-item label="支付方式" class="model_span_form" :label-col="{ span: 4 }"
                    :wrapper-col="{ span: 20 }">
                    <span>{{ purchaseData.purchase.bizGoodsInfos[0].paymentMethod }}</span>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item label="到货日期" class="model_span_form" :label-col="{ span: 4 }"
                    :wrapper-col="{ span: 20 }">
                    <span>{{ purchaseData.purchase.bizGoodsInfos[0].arrivalDate }}</span>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="12">
                  <a-form-model-item label="采购状态" class="model_span_form" :label-col="{ span: 4 }"
                    :wrapper-col="{ span: 20 }">
                    <span>{{ purchaseData.purchase.bizGoodsInfos[0].purchaseStatus }}</span>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item label="付款人" class="model_span_form" :label-col="{ span: 4 }"
                    :wrapper-col="{ span: 20 }">
                    <span>{{ purchaseData.purchase.bizGoodsInfos[0].payer }}</span>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="12">
                  <a-form-model-item label="付款时间" class="model_span_form" :label-col="{ span: 4 }"
                    :wrapper-col="{ span: 20 }">
                    <span>{{ purchaseData.purchase.bizGoodsInfos[0].payTime }}</span>
                  </a-form-model-item>
                </a-col>

              </a-row>
            </a-form>
          </div>
          <div class="title">
            <span>审批流程</span>
          </div>
          <div class="content">
            <div class="stpe_box">
              <div class="stpe_item" v-for="(item, index) in stpespurchase" :key="index">
                <div class="center">
                  <div class="center_val" :style="{ background: item.flag ? color : '' }">
                    <div class="item" :style="{ color: item.flag ? '#fff' : '' }">{{ item.name }}
                    </div>
                    <div class="item minItem" :style="{ color: item.flag ? '#fff' : '' }">{{
                        item.auditor
                    }} </div>

                    <div class="item minItem" :style="{ color: item.flag ? '#fff' : '' }">{{
                        item.endTime
                    }}</div>
                    <div class="records" v-for="(user, idx) in item.records" :key="idx">
                      <div class="recordsTop" :style="{ color: item.flag ? '#fff' : '' }">
                        {{ user.source }}转交至{{ user.target }}
                      </div>
                      <div class="recordsTop" :style="{ color: item.flag ? '#fff' : '' }">{{
                          user.createTime
                      }}</div>
                      <div class="recordsTop" :style="{ color: item.flag ? '#fff' : '' }">{{
                          user.reason
                      }}</div>
                    </div>
                  </div>
                </div>
                <div class="stepRound" :style="{ background: item.flag ? color : '' }"></div>
                <div class="stepLine" :style="{ background: item.flag ? color : '' }"
                  v-if="index != stpespurchase.length - 1"></div>
              </div>
            </div>
          </div>
          <div class="title">
            <span>采购流程</span>
          </div>
          <div class="content">
            <div class="stpe_box">
              <div class="stpe_item" v-for="(item, index) in purchspay" :key="index">
                <div class="center">
                  <div class="center_val" :style="{ background: item.id ? '#5B8FF9' : '' }">
                    <div class="item" :style="{ color: item.id ? '#fff' : '' }">{{ item.link }}
                    </div>
                    <div class="item minItem" :style="{ color: item.id ? '#fff' : '' }">{{
                        item.userName
                    }}</div>
                    <div class="item minItem" :style="{ color: item.id ? '#fff' : '' }">{{
                        item.createTime
                    }}</div>
                    <div class="item minItem" :style="{ color: item.id ? '#fff' : '' }" v-if="item.users != null">被移交人：
                    </div>
                    <div class="item minItem" :style="{ color: item.id ? '#fff' : '' }" v-if="item.users != null">
                      <div class="item minItem" :style="{ color: item.id ? '#fff' : '' }"
                        v-for="(item1, index) in item.users" :key="index">{{ item.users[index]
                        }}
                      </div>

                    </div>
                  </div>
                </div>
                <div class="stepRound" style="background-color: #5B8FF9;"></div>
                <div class="stepLine" style="background-color: #5B8FF9;" v-if="index != purchspay.length - 1"></div>
              </div>
            </div>
          </div>
          <div class="title">
            <span>供应商报价</span>
          </div>
          <div class="content" v-if="supplierList.length">
            <a-table :data-source="supplierList" bordered :pagination="false">
              <a-table-column key="index" title="序号" data-index="index">
                <template scope="text, record, index">{{ index + 1 }}</template>
              </a-table-column>
              <a-table-column key="supplierName" ellipsis="true" title="供应商名称" data-index="supplierName">
              </a-table-column>
              <a-table-column key="quote" ellipsis="true" title="报价（单价）" data-index="quote">
              </a-table-column>
              <a-table-column key="remark" ellipsis="true" title="备注" data-index="remark">
              </a-table-column>
            </a-table>
          </div>
        </a-modal>
      </a-tab-pane>
      <a-tab-pane key="2" tab="品类清单" force-render>
        <Category ref="category"></Category>
      </a-tab-pane>
    </a-tabs>
    <!-- <ScrapInformation ref="scrapInformation"></ScrapInformation> -->
  </div>
</template>
<script>
import { getDictDataList } from '@/api/system'
// import { ScrapInformation } from './component/scrapInformation.vue'
import { limitCompany } from '@/utils/limitCompany'
import { downLoadXlxs2 } from '@/utils/index'
import { categoryNameList, getCategoryList } from '@/api/question'
import tableDragResize from '@/mixins/tableDragResize'
import { goods_record, tree_all, enableParent } from '@/api/purchase'
import {
  get_list,
  purchase,
  dict,
  dept_get,
  batch_save_value,
  update,
  // get_dept_tree,
  remove,
  asset_remove,
  get_list2_xlsx,
  daily_list,
  scrapped_apply_asset,
  purchase_apply_asset,
  assetInfo,
  assetDeatil,
  assetList
} from '@/api/assetmenag'
import { getDeptListEnable, getDeptListEnable2 } from '@/api/system'
import { checkPermission } from '@/utils/permissions'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import storage from 'store'
import { get_users2, get_dict } from '@/utils/unit_axios'
import preview from '@/components/module/prview'
import Category from '@/views/assetmenag/category.vue'
import { modalMap, purchase_apply_quote, get_process_all } from '@/api/activiti'
import { millsToTime } from '@/utils/util'
import { values } from 'store/storages/all'
const deptMap = {}
const columns = [
  {
    title: '序号',
    dataIndex: 'index',
    key: 'index',
    scopedSlots: {
      customRender: 'index',
    },
    width: 70,
    ellipsis: true,
  },
  {
    title: '所属公司',
    dataIndex: 'company_name',
    key: 'company_name',
    width: 120,
    ellipsis: true,
  },
  {
    title: '所属部门',
    dataIndex: 'dept_name',
    key: 'dept_name',
    width: 120,
    ellipsis: true,
  },
  {
    title: '资产类别',
    dataIndex: 'asset_type',
    key: 'asset_type',
    scopedSlots: {
      customRender: 'asset_type',
    },
    width: 150,
    ellipsis: true,
  },
  {
    title: '物品名称',
    dataIndex: 'name',
    key: 'name',
    width: 150,
    ellipsis: true,
  },
  {
    title: '物品编号',
    dataIndex: 'asset_sn',
    key: 'asset_sn',
    width: 150,
    ellipsis: true,
  },
  {
    title: '品类名称',
    dataIndex: 'category_name',
    key: 'category_name',
    width: 150,
    ellipsis: true,
  },
  {
    title: '规格型号',
    dataIndex: 'model',
    key: 'model',
    width: 300,
    ellipsis: true,
  },
  {
    title: '物品单位',
    dataIndex: 'unit',
    key: 'unit',
    width: 150,
    ellipsis: true,
  },
  {
    title: '物品状态',
    dataIndex: 'state',
    key: 'state',
    scopedSlots: {
      customRender: 'state',
    },
    width: 150,
    ellipsis: true,
  },
  {
    title: '是否检定',
    dataIndex: 'is_inspected',
    key: 'is_inspected',
    scopedSlots: {
      customRender: 'is_inspected',
    },
    width: 150,
    ellipsis: true,
  },
  {
    title: '准用说明',
    dataIndex: 'permit',
    key: 'permit',
    width: 150,
    ellipsis: true,
  },
  {
    title: '责任人',
    dataIndex: 'charger',
    key: 'charger',
    width: 150,
    ellipsis: true,
  },
  {
    title: '保管人',
    dataIndex: 'keeper',
    key: 'keeper',
    width: 150,
    ellipsis: true,
  },
  {
    title: '供应商',
    dataIndex: 'dealer',
    key: 'dealer',
    width: 150,
    ellipsis: true,
  },
  {
    title: '当前估值',
    dataIndex: 'value',
    key: 'value',
    width: 150,
    ellipsis: true,
  },
  {
    title: '采购单价',
    dataIndex: 'purchase_price',
    key: 'purchase_price',
    width: 150,
    ellipsis: true,
  },
  {
    title: '采购日期',
    dataIndex: 'purchase_time',
    key: 'purchase_time',
    width: 150,
    ellipsis: true,
  },
  {
    title: '备注',
    dataIndex: 'notes',
    key: 'notes',
    width: 150,
    ellipsis: true,
  },
  {
    title: '录入人',
    dataIndex: 'create_by',
    key: 'create_by',
    width: 150,
    ellipsis: true,
  },
  {
    title: '录入时间',
    dataIndex: 'create_time',
    key: 'create_time',
    width: 200,
    ellipsis: true,
  },
  {
    title: '维护人',
    dataIndex: 'update_by',
    key: 'update_by',
    width: 150,
    ellipsis: true,
  },
  {
    title: '维护时间',
    dataIndex: 'update_time',
    key: 'update_time',
    width: 200,
    ellipsis: true,
  },
  {
    title: '标签打印',
    dataIndex: 'is_labelled',
    key: 'is_labelled',
    width: 150,
    scopedSlots: {
      customRender: 'is_labelled',
    },
    ellipsis: true,
  },
  {
    title: '物品图片',
    dataIndex: 'img',
    width: 150,
    key: 'img',
    scopedSlots: {
      customRender: 'img',
    },
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: {
      customRender: 'action',
    },
    fixed: 'right',
    width: 150,
  },
]
const columns2 = [
  {
    title: '资产类别',
    dataIndex: 'asset_type',
    key: 'asset_type',
    scopedSlots: {
      customRender: 'asset_type',
    },
  },
  {
    title: '物品名称',
    dataIndex: 'asset',
    key: 'asset',
  },
  {
    title: '物品编号',
    dataIndex: 'asset_sn',
    key: 'asset_sn',
  },
  {
    title: '规格规格',
    dataIndex: 'model',
    key: 'model',
  },
  {
    title: '物品数量',
    dataIndex: 'amount',
    key: 'amount',
  },
  {
    title: '物品状态',
    dataIndex: 'state',
    key: 'state',
    scopedSlots: {
      customRender: 'state',
    },
  },
  {
    title: '准用说明',
    dataIndex: 'permit',
    key: 'permit',
  },
  {
    title: '采购时间',
    dataIndex: 'purchase_time',
    key: 'purchase_time',
  },
  {
    title: '采购单价',
    dataIndex: 'purchase_price',
    key: 'purchase_price',
  },
  {
    title: '供应商',
    dataIndex: 'dealer',
    key: 'dealer',
  },
  {
    title: '责任人',
    dataIndex: 'charger',
    key: 'charger',
  },
  {
    title: '责任部门',
    dataIndex: 'dept_id',
    key: 'dept_id',
    scopedSlots: {
      customRender: 'dept_id',
    },
  },
  {
    title: '上次检定结果',
    dataIndex: 'inspect_result',
    key: 'inspect_result',
  },
  {
    title: '上次检定时间',
    dataIndex: 'inspect_time',
    key: 'inspect_time',
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: {
      customRender: 'action',
    },
  },
]
const columns3 = [
  {
    title: '领用单号',
    dataIndex: 'amo',
    key: 'amo',
  },
  {
    title: '部门',
    dataIndex: 'dept_id',
    key: 'dept_id',
    scopedSlots: {
      customRender: 'dept_id',
    },
  },
  {
    title: '领用人',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '产品名',
    dataIndex: 'asset',
    key: 'asset',
  },
  {
    title: '产品编号',
    dataIndex: 'asset_sn',
    key: 'asset_sn',
  },
  {
    title: '数量',
    dataIndex: 'amount',
    key: 'amount',
  },
  {
    title: '领用时间',
    dataIndex: 'amo',
    key: 'amo',
  },
]
const columns4 = [
  {
    title: '物品名称',
    dataIndex: 'name',
    key: 'name',
    ellipsis: true,
  },
  {
    title: '规格型号',
    dataIndex: 'model',
    key: 'model',
    ellipsis: true,
  },
  {
    title: '物品编号',
    dataIndex: 'asset_sn',
    key: 'asset_sn',
    ellipsis: true,
  },
  {
    title: '当前估值',
    dataIndex: 'value',
    key: 'value',
    scopedSlots: {
      customRender: 'value',
    },
    width: 150,
    ellipsis: true,
  },
]
const resultMap = {
  1: '处理中',
  2: '通过',
  3: '驳回',
  4: '撤销',
}
export default {
  mixins: [tableDragResize],
  data() {
    return {
      dictList: [],
      labList: [],
      classify: false,
      deviceId: false,
      statusMap7: {
        '1': '在用',
        '2': '准用',
        '3': '待修',
        '4': '维修',
        '5': '检定',
        '6': '报废',
        '7': '外借',
        '8': '停用',
        '10': '库存'
      },
      category_name: '',
      deptList: [],
      deptData: [],
      timeout: null,
      preUrl: process.env.VUE_APP_API_BASE_URL + '/file/file/upload_asset',
      nameList: [],
      keeper: '',
      file_name: '',
      file_name2: '',
      statusMap: '',
      plainOptions: [],
      is_uplaod: false,
      is_uplaod2: false,
      is_uplaod3: false,
      is_uplaod4: false,
      fileList: [],
      removeList: [],
      defaultFileList: [],
      fileList2: [],
      removeList2: [],
      defaultFileList2: [],
      scroll_y: 150,
      deptMap,
      operTypeMap: {},
      changevisible: false,
      company_id: undefined,
      dept_id: undefined,
      data: [],
      companylist: [],
      companyData: [],
      deptlist: [],
      data2: [],
      data3: [],
      headers: {},
      deptTree: [],
      deptTree2: [],
      assettype: [],
      columns,
      columns2,
      columns3,
      columns4,
      upload: {
        asset_sn: '',
        dept_id: '',
      },
      upload2: {
        asset_sn: '',
        dept_id: '',
      },
      visible: false,
      visibleClaim: false,
      visibleexamine: false,
      editvisible: false,
      loading: false,
      Warehousingvisible: false,
      selectedRowKeys: [],
      selectedRow: [],
      name: '',
      asset_sn: '',
      state: undefined,
      asset_type: undefined,
      is_labelled: undefined,
      has_pic: undefined,
      start_date: '',
      num: 1,
      end_date: '',
      name2: '',
      charger: '',
      asset_sn2: '',
      state2: '',
      purchase_time2: '',
      pageSize: 10,
      current: 1,
      total: 0,
      pageSize2: 10,
      current2: 1,
      total2: 0,
      pageSize3: 10,
      current3: 1,
      total3: 0,
      detailsrow: {
        category_id: '',
        category_name: '',
      },
      categoryId: '',
      Warehousingrow: {},
      dates: [],
      visible2: false,
      detailsvisible: false,
      form2: this.$form.createForm(this),
      categoryName: '',
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 18,
      },
      rules: {
        dept_id: [
          {
            required: true,
            message: '请选择责任部门！',
            trigger: 'blur',
          },
        ],
        charger: [
          {
            required: true,
            message: '请输入责任人！',
            trigger: 'blur',
          },
        ],
      },
      assetsExportConsumables: checkPermission('assetmenag:consumables:assetsExport'),
      assetsUpdateMoneyConsumables: checkPermission('assetmenag:consumables:assetsUpdateMoney'),
      assetsUpdateConsumables: checkPermission('assetmenag:consumables:assetsUpdate'),
      assetsInfoConsumables: checkPermission('assetmenag:consumables:assetsInfo'),
      assetsInputConsumables: checkPermission('assetmenag:consumables:assetsInput'),
      //报废详情
      is_scrapped: false,
      scrapData: '',
      // 表头
      scrapcolumns: [
        {
          title: '序号',
          scopedSlots: {
            customRender: 'serial',
          },
        },
        {
          title: '申请标题',
          dataIndex: 'title',
          ellipsis: true,
        },
        {
          title: '审批节点',
          dataIndex: 'taskName',
          ellipsis: true,
        },
        {
          title: '审批人',
          dataIndex: 'auditor',
          scopedSlots: {
            customRender: 'auditor',
          },
        },
        {
          title: '审批意见',
          dataIndex: 'comment',
          ellipsis: true,
        },
        {
          title: '审批结果',
          dataIndex: 'result',
          scopedSlots: {
            customRender: 'result',
          },
        },
        {
          title: '耗时',
          dataIndex: 'duration',
          customRender: (text) => millsToTime(text),
        },
        {
          title: '下发时间',
          dataIndex: 'startTime',
          ellipsis: true,
        },
        {
          title: '审批时间',
          dataIndex: 'endTime',
          ellipsis: true,
        },
      ],
      stpesScrpd: [],
      purchaseData: '',
      is_purchase: false,
      supplierList: [],
      stpespurchase: [],
      purchspay: [],
      accrued: [
        {
          link: '待采购',
        },
        {
          link: '已下单',
        },
        {
          link: '已到货',
        },
        {
          link: '已验收',
        },
        {
          link: '已入库',
        },
        {
          link: '已移交',
        },
      ],
    }
  },
  components: {
    preview,
    Category,
  },
  computed: {
    hasSelected() {
      return this.selectedRowKeys.length > 0
    },
    components: {
      preview,
      Category,
      // ScrapInformation
    },
    watch: {
      fileList() {
        console.log(this.fileList, 'this.fileList=========================22222222222222222222222222')
      },
    },
    computed: {
      hasSelected() {
        return this.selectedRowKeys.length > 0
      },
      assets: {
        get() {
          return this.detailsrow.asset_type ? this.operTypeMap[this.detailsrow.asset_type].text : undefined
        },
        set(value) {
          this.detailsrow.asset_type = value
        },
      },
      states: {
        get() {
          return this.detailsrow.state ? this.statusMap[this.detailsrow.state] : undefined
        },
        set(value) {
          this.detailsrow.state = value
        },
      },
      isinstrument: {
        get() {
          return this.detailsrow.is_inspected ? this.instrumentMap[this.detailsrow.is_inspected] : undefined
        },
        set(value) {
          this.detailsrow.is_inspected = value
        },
      },
    },
  },
  filters: {
    operTypeFilter(type) {
      return operTypeMap[type].text
    },
    deptFilter(type) {
      return deptMap[type].text
    },
    resultFilter(type) {
      return type ? resultMap[type] : '待审批'
    },
  },
  created() {

    enableParent().then(res => {
      var data = []
      var data1 = {}
      res.rows.forEach(item => {
        if (item.isCompany == 0) {
          if (data.length != 0) {
            data.forEach(item1 => {
              if (item1.deptId != item.deptId) {
                data1 = {
                  deptId: item.deptId,
                  title: item.deptName,
                  parentId: item.parentId
                }
              }

            })
            data[item.deptId] = data1
          } else {
            data1 = {
              deptId: item.deptId,
              title: item.deptName,
              parentId: item.parentId
            }
            data[item.deptId] = data1
          }
        }
      })
      this.deptMap = data

      console.log(this.deptMap, 'this.deptMa999999999999999999999999999999')
    })

    limitCompany().then(res => {
      res.forEach(item => {
        if (item.deptId) {
          this.companylist.push(item)
        }
      })
      this.companylist.forEach(item => {
        if (item.deptId == this.$store.state.user.info.companyId) {
          this.deptTree = item.children
        }
      })
    })
    this.get_lis()
    get_dict('goodStatus', (res) => {
      for (let i in res) {
        if (res[i] == '退货') {
          delete res[i]
        }
      }
      this.statusMap = res
    })
    //   enableParent().then((res) => {
    // let enableData = []
    // res.rows.forEach((item) => {
    // 	enableData.push(item.deptId)
    // })
    // tree_all().then((res) => {
    // 	if (res.code == 200) {
    // 	this.companyData = res.data[0]
    // 	let data = []
    // 	for (let i = 0; i < this.companyData.length; i++) {
    // 		let company = this.companyData[i]
    // 		if (enableData.includes(company.deptId) && !data[i]) {
    // 		data[i] = {
    // 			deptId: company.deptId,
    // 			parentId: company.parentId,
    // 			title: company.title,
    // 			value: company.value,
    // 			children: [],
    // 		}
    // 		}
    // 		for (let j = 0; j < company.children.length; j++) {
    // 		let children = company.children[j]
    // 		if (enableData.includes(children.deptId)) {
    // 			if (!data[i]) {
    // 			data[i] = {
    // 				deptId: company.deptId,
    // 				parentId: company.parentId,
    // 				title: company.title,
    // 				value: company.value,
    // 				children: [],
    // 			}
    // 			}
    // 			if (!data[i].children[j]) {
    // 			data[i].children[j] = {
    // 				deptId: children.deptId,
    // 				parentId: children.parentId,
    // 				title: children.title,
    // 				value: children.value,
    // 				children: [],
    // 			}
    // 			}
    // 		}
    // 		for (let k = 0; k < children.children.length; k++) {
    // 			let children_k = children.children[k]
    // 			if (enableData.includes(children.deptId)) {
    // 			if (!data[i]) {
    // 				data[i] = {
    // 				deptId: company.deptId,
    // 				parentId: company.parentId,
    // 				title: company.title,
    // 				value: company.value,
    // 				children: [],
    // 				}
    // 			}
    // 			if (!data[i].children[j]) {
    // 				data[i].children[j] = {
    // 				deptId: children.deptId,
    // 				parentId: children.parentId,
    // 				title: children.title,
    // 				value: children.value,
    // 				children: [],
    // 				}
    // 			}
    // 			if (!data[i].children[j].children[k]) {
    // 				data[i].children[j].children[k] = {
    // 				deptId: children_k.deptId,
    // 				parentId: children_k.parentId,
    // 				title: children_k.title,
    // 				value: children_k.value,
    // 				children: [],
    // 				}
    // 			}
    // 			}
    // 		}
    // 		}
    // 	}
    // 	this.companylist = data
    // 	console.log(data, 'enibledata++++++++++++++')
    // 	}
    //    })
    //   })
    // tree_all().then(res => {
    // 	if (res.code == 200) {
    // 		this.companyData = res.data[0]
    // 	}
    // })
    // get_dept_tree().then((res) => {
    // 	this.companylist = res.data.dept_lis
    // 	this.companylist.unshift({
    // 		dept_id: 0,
    // 		dept_name: '所有公司',
    // 		child_lis: [],
    // 	})
    // })
    dict({
      pageNum: 1,
      pageSize: 10,
      dictType: 'assets_type',
    }).then((res) => {
      this.assettype = res.rows
      this.assettype.map((d) => {
        this.operTypeMap[d.dictCode] = {
          text: d.dictLabel,
        }
      })
    })

    // getDeptListEnable2().then((res) => {
    //   const data = res.rows
    //   if (data.length > 0) {
    //     const min = Math.min(...data.map((m) => m.parentId))
    //     this.buildtree2(data, this.deptTree, min)
    //     this.deptTree.map((d) => {
    //       if (d.hasOwnProperty('children')) {
    //         d.children.map((b) => {
    //           if (b.hasOwnProperty('children')) {
    //             b.children.map((a) => {
    //               deptMap[a.key] = {
    //                 text: a.title,
    //               }
    //             })
    //           }
    //           deptMap[b.key] = {
    //             text: b.title,
    //           }
    //           deptMap[d.key] = {
    //             text: d.title,
    //           }
    //         })
    //       } else {
    //         deptMap[d.key] = {
    //           text: d.title,
    //         }
    //       }
    //     })
    //     this.expandedKeys = data.map((m) => m.parentId)
    //     this.dataList = data.map((m) => {
    //       return {
    //         key: m.deptId,
    //         title: m.deptName,
    //       }
    //     })
    //   }
    // })
  },
  mounted() {
    this.$nextTick(() => {
      var max_h = $('#content_main_center_scroll').height()
      console.log(max_h, 'sssssssss')
      setTimeout(() => {
        console.log($('.ant-table-header').height(), 'aaaaaaaaaaaaa')
        this.scroll_y = max_h - $('.ant-table-header').height()
      }, 1000)
    })
  },
  methods: {
    // 获取子分类
    getLabList(e) {
      console.log(e, 'eeeeeeeeeeeeeeeeeeeee')
      if (e) {
        this.deviceId = true
      } else {
        this.deviceId = false
      }
      // console.log(this.deviceId, 'eeeeeeeeeeeeeeeeee==============')
      var data = ''
      if(e) {
        this.dictList.forEach(item => {
          if (item.dictValue == e) {
            data = item
          }
        })
        getDictDataList({
          // dictLabel
          // dictType: 'lab_device'
          dictType: data.dictLabel
        }).then(res => {
          this.labList = res.rows
          // console.log(res.rows, '111111111111111111111111111111111')
        })
      } else{
        this.detailsrow.dict_key = undefined
      }
      
    },
    //获取一起分类
    getDictList() {
      console.log('3333333333333333333333333333')
      getDictDataList({
        dictType: 'device_type'
      }).then(res => {
        this.dictList = res.rows
        console.log(res.rows, '2222222222222222222222222222')

      })
    },
    changeAsset(e) {
      if (e === 53) {
        this.classify = true
        this.getDictList()
      } else {
         this.classify = false
      }
      console.log(this.form2.asset_type, '22222222222222222222222')

    },
    callback(key) {
      console.log(key, 'key======================')
      switch (key) {
        case '1':
          this.get_lis()
          break
        case '2':
          this.$refs.category.getList()
          break
      }
    },
    scrappedClick() {
      scrapped_apply_asset({ assetId: this.detailsrow.id }).then(res => {
        if (res.code != 200) {
          this.$message.error(res.msg);
          return
        }
        if (res.data == null) {
          this.$message.error('没有相关信息！');
          return
        }
        var flows = res.data.history.tasks
        var result = 0
        for (let i = 0, l = flows.length; i < l; i++) {
          if (i + 1 < flows.length) {
            if (flows[i + 1].flag) {
              flows[i]['is_line'] = true
            }
          }
          if (flows[i].result == 3) {
            result = 3
          } else if (flows[i].result == 2) {
            result = 2
          } else if (flows[i].result == 4) {
            result = 4
          }
        }
        flows.forEach((item) => {
          item['result'] = result
          Object.assign(item, {
            auditorRrr: item.auditor.split('、')
          })

        })
        if (result == 3) {
          this.color = '#F56C6C'
        } else if (result == 2) {
          this.color = '#5B8FF9'
        } else if (result == 4) {
          this.color = '#CCCCCC'
        } else {
          this.color = '#5B8FF9'
        }
        this.stpesScrpd = flows;
        console.log(this.stpesScrpd)
        this.scrapData = res.data

        this.is_scrapped = true;

      })


    },
    getDataList(id) {
      getCategoryList({
        pageIndex: 1,
        pageSize: 999,
        companyId: id,
      }).then((res) => {
        if (res.code == 200) {
          this.nameList = res.data.list
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    getName(id) {
      //获得品类名称列表
      categoryNameList({
        companyId: id,
      }).then((res) => {
        if (res.code == 200) {
          this.nameList = res.data
          console.log(res, 'res==============')
        }
        console.log(this.nameList, 'nameList===========')
      })
    },
    changeCategoryName(e) {
      this.nameList.forEach((item) => {
        if (item.id == e) {
          console.log(e, 'eeeeeeeeeeeeeee')
          console.log(this.detailsrow.category_name, 'this.detailsrow.category_name==================')
          this.detailsrow.category_name = item.category_name
          this.detailsrow.category_id = item.id
          this.$forceUpdate()
        }
      })
    },
    changeCategoryName1(e) {
      console.log(e, 'eeeeeeeeeeeeeeeeeeeeeeee')
      this.nameList.forEach((item) => {
        if (item.id == e) {
          this.categoryId = item.id
          // this.categoryName = item.categoryName

          // this.form2.category_Name = item.categoryName
          // console.log(this.form2.category_Name, 'this.form2.category_Name=====================')
        }
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    disabledDate(current) {
      // Can not select days before today and today
      return current && current > moment().endOf('day')
    },
    changevalue() {
      this.form2.setFieldsValue({
        value: this.form2.getFieldValue('purchase_price'),
      })
    },
    // editCancel() {
    // 	this.editvisible = false
    // },
    deletes(row) {
      asset_remove({
        id: row.id,
      }).then((res) => {
        this.$message.success('删除成功！')
      })
    },
    // 上传各式限制
    beforeUpload(file) {
      const tok = storage.get(ACCESS_TOKEN)
      this.headers = {
        token: tok,
      }
      this.upload.asset_sn = this.detailsrow.asset_sn
      this.upload.dept_id = this.detailsrow.dept_id
      var isType = true
      this.file_name = file.name
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!isLt2M) {
        this.$message.error('上传头文件大小不能超过 10MB!')
      }
      if (file.type != 'application/pdf') {
        isType = false
        this.$message.error('只能上传pdf文件')
      }
      return isLt2M && isType
    },
    beforeUpload2(file) {
      const tok = storage.get(ACCESS_TOKEN)
      this.headers = {
        token: tok,
      }
      this.upload2.asset_sn = this.detailsrow.asset_sn
      this.upload2.dept_id = this.detailsrow.dept_id
      var isType = true
      this.file_name2 = file.name
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!isLt2M) {
        this.$message.error('上传头文件大小不能超过 10MB!')
      }
      if (file.type != 'application/pdf') {
        isType = false
        this.$message.error('只能上传pdf文件')
      }
      return isLt2M && isType
    },
    //上传文件
    handleChange(info) {
      info.fileList.forEach((item, idx) => {
        if (item.type != 'application/pdf') {
          info.fileList.splice(idx, 1)
        }
      })
      if (info.file.status !== 'uploading') {
        // info.fileList.splice(info.fileList.length - 1, 1)
      }
      if (info.file.status === 'done') {
        this.$message.success('上传成功')
        this.fileList.push(info.file.response.data + ',' + info.file.name)
        // info.fileList.push(info.file)
      } else if (info.file.status === 'error') {
        this.$message.error('上传失败')
      }
    },
    //上传文件
    // handleChange2(info) {
    // 	info.fileList.forEach((item, idx) => {
    // 		if (item.type != 'application/pdf') {
    // 			info.fileList.splice(idx, 1)
    // 		}
    // 	})
    // 	if (info.file.status !== 'uploading') {
    // 		// info.fileList.splice(info.fileList.length - 1, 1)
    // 	}
    // 	if (info.file.status === 'done') {
    // 		this.$message.success('上传成功')
    // 		this.fileList2.push(info.file.response.data + ',' + info.file.name)
    // 		// info.fileList.push(info.file)
    // 	} else if (info.file.status === 'error') {
    // 		this.$message.error('上传失败')
    // 	}
    // },
    //删除文件
    removeFile(file) {
      this.removeList.push(file.response.data)
      let data = file.response.data + ',' + file.name
      this.fileList.forEach((item, idx) => {
        if (item == data) {
          this.fileList.splice(idx, 1)
        }
      })
      console.log(this.fileList, this.defaultFileList)
    },
    //删除文件
    removeFile2(file) {
      this.removeList2.push(file.response.data)
      let data = file.response.data + ',' + file.name
      this.fileList2.forEach((item, idx) => {
        if (item == data) {
          this.fileList2.splice(idx, 1)
        }
      })
      console.log(this.fileList, this.defaultFileList)
    },
    //预览文件
    previewFile(file) {
      console.log(file)
      window.open('https://coa.anliantest.com/oaProxyApi/proxyPython/file/download?path=' + file.response.data)
    },
    leaderid(id) {
      this.$nextTick(() => {
        this.form2.setFieldsValue({
          keeper: undefined,
        })
      })
      dept_get(id).then((res) => {
        this.form2.setFieldsValue({
          charger: res.leader,
        })
      })
      get_users2(id, (res) => {
        this.plainOptions = res
      })
    },
    editCancel() {
      this.defaultFileList2 = []
      this.editvisible = false
    },
    deletes(row) {
      asset_remove({
        id: row.id,
      }).then((res) => {
        this.$message.success('删除成功！')
      })
    },
    // 上传各式限制
    beforeUpload(file) {
      const tok = storage.get(ACCESS_TOKEN)
      this.headers = {
        token: tok,
      }
      this.upload.asset_sn = this.detailsrow.asset_sn
      this.upload.dept_id = this.detailsrow.dept_id
      var isType = true
      this.file_name = file.name
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!isLt2M) {
        this.$message.error('上传头文件大小不能超过 10MB!')
      }
      if (file.type != 'application/pdf') {
        isType = false
        this.$message.error('只能上传pdf文件')
      }
      return isLt2M && isType
    },
    beforeUpload2(file) {
      const tok = storage.get(ACCESS_TOKEN)
      this.headers = {
        token: tok,
      }
      this.upload2.asset_sn = this.detailsrow.asset_sn
      this.upload2.dept_id = this.detailsrow.dept_id
      var isType = true
      this.file_name2 = file.name
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!isLt2M) {
        this.$message.error('上传头文件大小不能超过 10MB!')
      }
      if (file.type != 'application/pdf') {
        isType = false
        this.$message.error('只能上传pdf文件')
      }
      return isLt2M && isType
    },
    //上传文件
    handleChange(info) {
      info.fileList.forEach((item, idx) => {
        if (item.type != 'application/pdf') {
          info.fileList.splice(idx, 1)
        }
      })
      if (info.file.status !== 'uploading') {
        // info.fileList.splice(info.fileList.length - 1, 1)
      }
      if (info.file.status === 'done') {
        if (info.file.response.code != 200) {
          info.fileList.forEach((item, idx) => {
            if (item.uid == info.file.uid) {
              info.fileList.splice(idx, 1)
            }
          })
          this.$message.error(info.file.response.msg)
          return
        }
        this.$message.success('上传成功')
        console.log(info, 'info========================')
        console.log(info.file.response.data, ' info.file.response.data================')
        // info.file.response.data + ',' +
        this.fileList.push(info.file.response.data.url + ',' + info.file.name)
        // info.fileList.push(info.file)
      } else if (info.file.status === 'error') {
        this.$message.error('上传失败')
      }
    },
    //上传文件
    handleChange2(info) {
      info.fileList.forEach((item, idx) => {
        if (item.type != 'application/pdf') {
          info.fileList.splice(idx, 1)
        }
      })
      if (info.file.status !== 'uploading') {
        // info.fileList.splice(info.fileList.length - 1, 1)
      }
      if (info.file.status === 'done') {
        if (info.file.response.code != 200) {
          info.fileList.forEach((item, idx) => {
            if (item.uid == info.file.uid) {
              info.fileList.splice(idx, 1)
            }
          })
          this.$message.error(info.file.response.msg)
          return
        }
        this.$message.success('上传成功')
        // info.file.response.data + ',' +
        this.fileList2.push(info.file.response.data.url + ',' + info.file.name)
        // info.fileList.push(info.file)
      } else if (info.file.status === 'error') {
        this.$message.error('上传失败')
      }
    },
    //删除文件
    removeFile(file) {
      this.removeList.push(file.response.data)
      let data = file.response.data + ',' + file.name
      this.fileList.forEach((item, idx) => {
        if (item == data) {
          this.fileList.splice(idx, 1)
        }
      })
      console.log(this.fileList, this.defaultFileList)
    },
    //删除文件
    removeFile2(file) {
      console.log(file, 'file====================')
      this.removeList2.push(file.response.data)
      let data = file.response.data + ',' + file.name
      this.fileList2.forEach((item, idx) => {
        if (item == data) {
          this.fileList2.splice(idx, 1)
        }
      })
      console.log(this.fileList, this.defaultFileList)
    },
    //预览文件
    previewFile(file) {
      console.log(file)
      window.open('https://coa.anliantest.com/oaProxyApi/proxyPython/file/download?path=' + file.response.data)
    },
    show_img(idx, imgs) {
      var arr = []
      for (var i = 0; i < imgs.length; i++) {
        arr[i] = {
          preUrl: imgs[i],
        }
      }
      var row = {
        index: idx,
        imgs: arr,
      }
      console.log(arr, 'arr=====================')
      this.$refs.preview.show(row)
    },
    result() {
      this.has_pic = undefined
      console.log('11111111111111111111111111111111111')
      this.is_labelled = undefined
      this.name = ''
      this.category_name = ''
      this.asset_type = undefined
      this.asset_sn = ''
      this.state = undefined
      this.dates = []
      this.start_date = ''
      this.end_date = ''
      this.charger = ''
      this.dept_id = undefined
      this.company_id = undefined
      this.keeper = ''
    },
    preservation2(e) {
      this.form2.validateFields((err, values) => {
        if (!err) {
          if (this.removeList.length > 0) {
            this.removeList.forEach((item) => {
              remove({
                path: item,
              }).then((res) => {
                console.log(res)
              })
            })
          }
          if (this.removeList2.length > 0) {
            this.removeList2.forEach((item) => {
              remove({
                path: item,
              }).then((res) => {
                console.log(res)
              })
            })
          }
          values['item_type'] = 1
          values['amount'] = 1
          values['create_by'] = this.$store.getters.userInfo.userName
          console.log(this.fileList, 'this.fileList========================')
          values['att_path'] = this.fileList.join(';')
          values['cert_path'] = this.fileList2.join(';')
          var value = values
          let resData = {}
          for (let key in value) {
            resData[key] = value[key]
            if (key == 'purchase_price' || key == 'value' || key == 'amount') {
              resData[key] = value[key]
            }
          }
          this.resData
          Object.assign(resData, {
            category_id: this.categoryId,
          })
          if (resData.arrive_time) {
            resData.arrive_time = resData.arrive_time + ' ' + '00:00:00'
          }
          if (resData.inspect_time) {
            resData.inspect_time = resData.inspect_time + ' ' + '00:00:00'
          }
          if (resData.purchase_time) {
            resData.purchase_time = resData.purchase_time + ' ' + '00:00:00'
          }
          console.log(resData, 'resdata===============')
          clearTimeout(this.timeout)
          this.timeout = setTimeout(() => {
            assetInfo({
              deviceType: resData.deviceType,
              dictKey: resData.dictkey,
              // singlePrice: resData.single_price,
              companyId: this.$store.state.user.info.companyId,
              amount: resData.amount,
              arriveTime: resData.arrive_time,
              assetSn: resData.asset_sn,
              assetType: resData.asset_type,
              attPath: resData.att_path,
              categoryId: resData.category_id,
              certPath: resData.cert_path,
              charger: resData.charger,
              createBy: resData.create_by,
              dealer: resData.dealer,
              deptId: resData.dept_id,
              factorySn: resData.factory_sn,
              inspectCycle: resData.inspect_cycle,
              inspectResult: resData.inspect_result,
              inspectTime: resData.inspect_time,
              isInspected: resData.is_inspected,
              // itemType: resData.item_type,
              keeper: resData.keeper,
              manufacturer: resData.manufacturer,
              model: resData.model,
              name: resData.name,
              notes: resData.notes,
              operator: resData.operator,
              permit: resData.permit,
              precisions: resData.precisions,
              purchasePrice: resData.purchase_price.toString(),
              purchaseTime: resData.purchase_time,
              state: resData.state,
              storageCond: resData.storage_cond,
              storageLoc: resData.storage_loc,
              unit: resData.unit,
              value: resData.value.toString(),
            })
              .then((res) => {
                if (res.code === 200) {
                  this.$message.success('保存成功')
                  this.$emit('ok')
                  this.visible2 = false
                  this.is_uplaod = false
                  this.is_uplaod4 = false
                  this.fileList = []
                  this.defaultFileList = []
                  this.removeList = []
                  this.fileList2 = []
                  this.defaultFileList2 = []
                  this.removeList2 = []
                  this.get_lis()
                  this.form2.resetFields()
                } else {
                  this.$message.error(res.msg)
                }
              })
              .catch(() => {
                this.$message.error('系统错误，请稍后再试')
              })
          }, 1000)

          // checkin(resData)
        }
      })
    },
    handleCancel2() {
      this.fileList = []
      this.fileList2 = []
      this.visible2 = false
      this.is_uplaod = false
      this.is_uplaod4 = false
      this.form2.resetFields()
    },
    // 	Input() {
    // 		this.defaultFileList = []
    // 		this.defaultFileList2 = []
    // 		// this.getName()
    // 		this.visible2 = true
    // 		this.form2.resetFields()
    // 		this.is_uplaod = true
    // 		this.is_uplaod4 = true
    // 		this.$nextTick(() => {
    // 			setTimeout(() => {
    // 				this.form2.setFieldsValue({
    // 					operator: this.$store.getters.userInfo.userName,
    // 	})
    // 	dept_get(id).then((res) => {
    // 		this.form2.setFieldsValue({
    // 			charger: res.leader,
    // 		})
    // 	})
    // 	get_users2(id, (res) => {
    // 		this.plainOptions = res
    // 	})
    // },
    Input() {
      this.classify = false
      this.deviceId = false
      // this.getLabList()
      // this.getDictList()
      this.getDataList(this.$store.state.user.info.companyId)
      this.visible2 = true
      // this.form2.resetFields()
      this.is_uplaod = true
      this.is_uplaod4 = true
      this.$nextTick(() => {
        setTimeout(() => {
          this.form2.setFieldsValue({
            operator: this.$store.getters.userInfo.userName,
          })
        })
      })
    },
    view_path(path) {
      window.open('https://coa.anliantest.com/oaProxyApi/proxyPython/file/download?path=' + path)
    },
    handlecompany(e) {
      this.dept_id = undefined
      for (let i = 0; i < this.companylist.length; i++) {
        if (this.company_id == this.companylist[i].deptId) {
          this.deptList = this.companylist[i].children
          break
        }
      }
    },
    // handledept(value) {
    // 	this.dept_id = value
    // },
    onChange(date, dateString) {
      this.dates = date
      this.start_date = date[0]
      this.end_date = date[1]
    },
    // onSelectChange(selectedRowKeys) {
    // 	console.log(selectedRowKeys, 'selectedRowKeys=====================================')
    // 	this.selectedRowKeys = selectedRowKeys
    // },
    showSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.get_lis()
    },
    // showSizeChange2(current, pageSize) {
    // 	this.pageSize2 = pageSize
    // 	this.current2 = current
    // 	this.get_che()
    // },
    onShowSizeChange(current, pageSize) {
      this.selectedRowKeys = []
      this.selectedRow = []
      this.current = current
      this.get_lis()
    },
    // onShowSizeChange2(current, pageSize) {
    // 	this.current2 = current
    // 	this.get_che()
    // },

    handlestate(value) {
      this.state = value
    },
    handlestate2(value) {
      this.state2 = value
    },
    moneyOk() {
      var list = []
      this.selectedRow.forEach((item) => {
        list.push({
          id: item.id,
          value: item.value * 100,
        })
      })
      batch_save_value({
        data: list,
      })
        .then((res) => {
          if (res.code == 200) {
            this.changevisible = false
            this.$message.success('保存成功')
          } else {
            this.$message.success(res.msg)
          }
        })
        .catch(() => {
          this.$message.error('系统错误，请稍后再试')
        })
    },
    moneyCancel() {
      this.changevisible = false
    },
    modification() {
      this.selectedRow = []
      this.selectedRowKeys.forEach((item) => {
        this.selectedRow.push(this.data[item])
      })
      this.changevisible = true
      console.log(this.selectedRow)
    },
    buildtree2(list, arr, parentId) {
      list.forEach((item) => {
        if (item.parentId === parentId) {
          var child = {
            key: item.deptId,
            value: item.deptId, // value是给modal的select用的，2者属性不一样
            title: item.deptName,
            scopedSlots: {
              title: 'title',
            },
            children: [],
          }
          this.buildtree2(list, child.children, item.deptId)
          if (child.children.length === 0) {
            delete child.children
          }
          arr.push(child)
        }
      })
    },
    get_lis() {
      daily_list({
        pageSize: this.pageSize,
        pageNum: this.current,
        name: this.name,
        category_name: this.category_name,
        asset_sn: this.asset_sn,
        asset_type: this.asset_type,
        state: this.state,
        start_date: this.start_date,
        end_date: this.end_date,
        dept_id: this.dept_id,
        company_id: this.company_id,
        charger: this.charger,
        is_labelled: this.is_labelled,
        has_pic: this.has_pic,
        keeper: this.keeper,
      }).then((res) => {
        this.total = res.total
        res.rows.forEach((item) => {
          if (item.purchase_time.indexOf(' ') != -1) {
            item.purchase_time = item.purchase_time.split(' ')[0]
          }
          if (item.inspect_time) {
            if (item.inspect_time.indexOf(' ') != -1) {
              item.inspect_time = item.inspect_time.split(' ')[0]
            }

          }

        })
        this.data = res.rows
      })
      // assetget_list2({
      // 	page_size: this.pageSize,
      // 	page_num: this.current,
      // 	name: this.name,
      // 	asset_sn: this.asset_sn,
      // 	asset_type: this.asset_type,
      // 	state: this.state,
      // 	start_date: this.start_date,
      // 	end_date: this.end_date,
      // 	dept_id: this.dept_id,
      // 	company_id: this.company_id,
      // 	charger: this.charger,
      // 	is_labelled: this.is_labelled,
      // 	has_pic: this.has_pic,
      // }).then((res) => {
      // 	this.total = res.data.total
      // 	this.data = res.data.items
      // 	this.data.forEach((item) => {
      // 		item.purchase_price = item.purchase_price / 100
      // 		item.value = item.value / 100
      // 		item.amount = item.amount / 100
      // 	})
      // })
    },
    // get_che() {
    // 	get_checkin({
    // 		page_size: this.pageSize2,
    // 		page_num: this.current2,
    // 		name: this.name2,
    // 		asset_sn: this.asset_sn2,
    // 		state: this.state2,
    // 	}).then((res) => {
    // 		this.total2 = res.data.total
    // 		this.data2 = res.data.items
    // 	})
    // },
    add() {
      this.visible = true
    },
    Exadd() {
      this.visibleClaim = true
    },
    examine() {
      this.visibleexamine = true
    },
    handleOk(e) {
      this.loading = true
      setTimeout(() => {
        this.visible = false
      })
    },
    handleOk2(e) {
      this.loading = true
      setTimeout(() => {
        this.visibleClaim = false
        this.loading = false
      }, 2000)
    },
    handleOk3(e) {
      this.loading = true
      setTimeout(() => {
        this.visibleexamine = false
        this.loading = false
      }, 2000)
    },
    query() {
      this.current = 1
      this.get_lis()
    },
    // search() {
    // 	this.current2 = 1
    // 	this.get_che()
    // },
    exp() {
      // get_list2_xlsx
      downLoadXlxs2(process.env.VUE_APP_API_BASE_URL + '/daily/asset/excel',
        {
          name: this.name,
          category_name: this.category_name,
          asset_sn: this.asset_sn,
          asset_type: this.asset_type,
          state: this.state,
          start_date: this.start_date,
          end_date: this.end_date,
          dept_id: this.dept_id,
          company_id: this.company_id,
          charger: this.charger,
          is_labelled: this.is_labelled,
          has_pic: this.has_pic,
          keeper: this.keeper,

        })
      // assetExcel({
      // 	page_size: 99999,
      // 	page_num: 1,
      // 	name: this.name,
      // 	asset_sn: this.asset_sn,
      // 	asset_type: this.asset_type,
      // 	state: this.state,
      // 	start_date: this.start_date,
      // 	end_date: this.end_date,
      // 	dept_id: this.dept_id,
      // 	company_id: this.company_id,
      // 	charger: this.charger,
      // 	is_labelled: this.is_labelled,
      // 	has_pic: this.has_pic,
      // 	excel: 1,
      // })
    },
    ort() {
      let a = document.createElement('a')
      a.href = 'https://coa.anliantest.com/oaProxyApi/proxyPython/asset/get_checkin_records?excel=1'
      a.download = 'test'
      a.click()
      // assetget_list2({
      // 	excel: 1
      // }).then(res => {
      // 	console.log(res)
      // })
    },
    Issueexport() {
      let a = document.createElement('a')
      a.href = 'https://coa.anliantest.com/oaProxyApi/proxyPython/asset/get_checkout_records?excel=1'
      a.download = 'test'
      a.click()
      // assetget_list2({
      // 	excel: 1
      // }).then(res => {
      // 	console.log(res)
      // })
    },
    details(data) {
      assetList({
        id: data.id,
      }).then(res => {
        if (res.code == 200) {
          var row = res.data
          // 	var row = {
          // purchase_price:	res.data.purchasePrice,
          // value: res.data.value,
          // amount: res.data.amount,
          // price: res.data.price,
          // spu_amount: res.data.spuAmount,
          // att_path: res.data.attPath,
          // accuracy_lv: res.data.accuracyLv,
          // arriveTime: res.data.arriveTime,
          // asset_sn: res.data.assetSn,
          // asset_type: res.data.assetType,
          // asset_type_name: res.data.assetTypeName,
          // attPathList: res.data.attPathList,
          // brand: res.data.brand,
          // category_id: res.data.categoryId,
          // certPath: res.data.certPath,
          // cert_path_list: res.data.certPathList,
          // charger: res.data.charger,
          // checkTime: res.data.checkTime,
          // checkin_type: res.data.checkinType,
          // company_id: res.data.companyId,
          // company_name: res.data.companyName,
          // createBy: res.data.createBy,
          // createTime: res.data.createTime,
          // dealer: res.data.dealer,
          // deptId: res.data.deptId,
          // dept_name: res.data.deptName,
          // expire_nime: res.data.expireTime,
          // factory_nn: res.data.factorySn,
          // fixed_value: res.data.fixedValue,
          // id: res.data.id,
          // id_: res.data.id_,
          // inspect_cycle: res.data.inspectCycle,
          // inspect_result: res.data.inspectResult,
          // inspect_time: res.data.inspectTime,
          // is_inspected: res.data.isInspected,
          // is_inspected_name: res.data.isInspectedName,
          // is_instrument: res.data.isInstrument,
          // is_labelled: res.data.isLabelled,
          // is_transfer: res.data.isTransfer,
          // is_virtual: res.data.isVirtual,
          // item_type: res.data.itemType,
          // item_type_name: res.data.itemTypeName,
          // keeper: res.data.keeper,
          // manufacturer: res.data.manufacturer,
          // measure_scope: res.data.measureScope,
          // model: res.data.model,
          // name: res.data.name,
          // next_inspect_time: res.data.nextInspectTime,
          // notes: res.data.notes,
          // operator: res.data.operator,
          // order_id: res.data.orderId,
          // permit: res.data.permit,
          // pic_path: res.data.picPath,
          // pic_path_tist: res.data.picPathList,
          // precisions: res.data.precisions,
          // purchase_amount: res.data.purchaseAmount,
          // purchaseTime: res.data.purchaseTime,
          // purchase_value: res.data.purchaseValue,
          // state: res.data.state,
          // state_name: res.data.stateName,
          // storage_cond: res.data.storageCond,
          // storage_loc: res.data.storageLoc,
          // transType: res.data.transType,
          // transTypeName: res.data.transTypeName,
          // unit: res.data.unit,
          // updateBy: res.data.updateBy,
          // updateTime: res.data.updateTime
          // }
          console.log('111111111111111111111111111111111111111111111111')
          this.detailsvisible = true
          console.log(row, 'row======================')
          if (row.arrive_time) {
            if (row.arrive_time.indexOf(' ') != -1) {
              row.arrive_time = row.arrive_time.split(' ')[0]
            }
          }
          if (row.purchase_time.indexOf(' ') != -1) {
            row.purchase_time = row.purchase_time.split(' ')[0]
          }
          this.detailsrow = row
          // this.detailsrow.category_id = row.category_name
          console.log(this.detailsrow.category_id, 'this.detailsrow.category_id==================')
          var att_paths = []
          var cert_paths = []
          if (row.att_path) {
            var as = row.att_path.split(';')
            as.forEach((item) => {
              att_paths.push({
                name: item.split(',')[1],
                response: {
                  data: item.split(',')[0],
                },
              })
            })
          }
          if (row.cert_path) {
            var as = row.cert_path.split(';')
            as.forEach((item) => {
              cert_paths.push({
                name: item.split(',')[1],
                response: {
                  data: item.split(',')[0],
                },
              })
            })
          }
          this.detailsrow.att_paths = att_paths
          this.detailsrow.cert_paths = cert_paths
        }
      })
      // this.detailsrow.pic_paths = row.pic_path ? row.pic_path.split(';') : []
    },
    // details(row) {
    // 	console.log('111111111111111111111111111111111111111111111111')
    // 	this.detailsvisible = true
    // 	this.detailsrow = row
    // 	// this.detailsrow.category_id = row.category_name
    // 	// console.log(this.detailsrow.category_id, 'this.detailsrow.category_id==================')
    // 	var att_paths = []
    // 	var cert_paths = []
    // 	if (row.att_path) {
    // 		var as = row.att_path.split(';')
    // 		as.forEach((item, index) => {
    // 			this.fileList.push(item)
    // 			this.defaultFileList.push({
    // 				uid: index + 1,
    // 				name: item.split(',')[1],
    // 				status: 'done',
    // 				url: item.split(',')[0],
    // 				response: {
    // 					data: item.split(',')[0],
    // 				},
    // 				type: 'application/pdf',
    // 			})
    // 		})
    // 	}
    // 	this.is_uplaod2 = true
    // }, 20)
    // setTimeout(() => {
    // 	if (row.cert_path) {
    // 		var as = row.cert_path.split(';')
    // 		as.forEach((item, index) => {
    // 			this.fileList2.push(item)
    // 			this.defaultFileList2.push({
    // 				uid: index + 1,
    // 				name: item.split(',')[1],
    // 				status: 'done',
    // 				url: item.split(',')[0],
    // 				response: {
    // 					data: item.split(',')[0],
    // 				},
    // 				type: 'application/pdf',
    // 			})
    // 		})
    // 	}
    // 	this.detailsrow.att_paths = att_paths
    // 	this.detailsrow.cert_paths = cert_paths
    // 	this.detailsrow.pic_paths = row.pic_path ? row.pic_path.split(';') : []
    // },
    Warehousingdetails(row) {
      this.Warehousingvisible = true
      this.Warehousingrow = row
      console.log(row)
    },
    WarehousingOk() {
      this.Warehousingvisible = false
    },
    WarehousingCancel() {
      this.Warehousingvisible = false
    },
    detailsOk() {
      this.detailsvisible = false
    },
    detailsCancel() {
      this.detailsvisible = false
    },
    getData(row) {
      getDictDataList({
        dictType: 'device_type'
      }).then(res => {
        if(res.code == 200) {
          this.dictList = res.rows
          if(row.device_type) {
          this.dictList.forEach(item => {
            if (item.dictValue == row.device_type) {
              getDictDataList({
                dictType: item.dictLabel
              }).then(res => {
                this.labList = res.rows
                console.log(res.rows, '888888888888888888888')
              })
            }
          })
        
        }
        }

      })

    },
    edit(row) {
      this.getData(row)
      this.getDataList(row.company_id)
      this.rowId = row.id
      // this.getName()
      this.defaultFileList = []
      this.fileList = []
      this.removeList = []
      this.defaultFileList2 = []
      this.fileList2 = []
      this.removeList2 = []
      this.is_uplaod2 = false
      this.is_uplaod3 = false
      setTimeout(() => {
        if (row.att_path) {
          var as = row.att_path.split(';')
          as.forEach((item, index) => {
            this.fileList.push(item)
            this.defaultFileList.push({
              uid: index + 1,
              name: item.split(',')[1],
              status: 'done',
              url: item.split(',')[0],
              response: {
                data: item.split(',')[0],
              },
              type: 'application/pdf',
            })
          })
        }
        this.is_uplaod2 = true
      }, 20)
      setTimeout(() => {
        if (row.cert_path) {
          var as = row.cert_path.split(';')
          as.forEach((item, index) => {
            this.fileList2.push(item)
            this.defaultFileList2.push({
              uid: index + 1,
              name: item.split(',')[1],
              status: 'done',
              url: item.split(',')[0],
              response: {
                data: item.split(',')[0],
              },
              type: 'application/pdf',
            })
          })
        }
        this.is_uplaod3 = true
      }, 20)
      // 	var rows = row
      // 	let resData = {}

      // 	for (let key in rows) {
      // 		resData[key] = rows[key]

      // 		resData['is_inspected'] = rows['is_inspected'] + ''
      // 		resData['update_by'] = this.$store.getters.userInfo.userName
      // 	this.is_uplaod3 = true
      // }, 20)
      var rows = JSON.parse(JSON.stringify(row))
      if (rows.arrive_time) {
        if (rows.arrive_time.indexOf(' ') != -1) {
          rows.arrive_time = rows.arrive_time.split(' ')[0]
        }
      }
      if (rows.purchase_time.indexOf(' ') != -1) {
        rows.purchase_time = rows.purchase_time.split(' ')[0]
      }
      let resData = {}

      for (let key in rows) {
        resData[key] = rows[key]

        resData['is_inspected'] = rows['is_inspected'] + ''
        resData['update_by'] = this.$store.getters.userInfo.userName
      }
      this.editvisible = true
      this.detailsrow = resData
      // this.detailsrow.category_id = JSON.parse(JSON.stringify(rows.category_name))
      // this.detailsrow.category_id = JSON.parse(JSON.stringify(rows.category_name))
      console.log(this.detailsrow, 'this.detailsrow.category_id================')
      // this.detailsrow.att_paths = row.att_path ? row.att_path.split(';') : []
      // this.detailsrow.pic_paths = row.pic_path ? row.pic_path.split(';') : []
    },
    editOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          var detailsrow = this.detailsrow
          if (this.removeList.length > 0) {
            this.removeList.forEach((item) => {
              remove({
                path: item,
              }).then((res) => {
                console.log(res)
              })
            })
          }
          if (this.removeList2.length > 0) {
            this.removeList2.forEach((item) => {
              remove({
                path: item,
              }).then((res) => {
                console.log(res)
              })
            })
          }
          let resData = {}
          for (let key in detailsrow) {
            resData[key] = detailsrow[key]
            // if(key=='arrive_time'||key=='check_time'||key=='create_time'||key=='expire_time'||key=='inspect_time'||key=='purchase_time'||key=='submit_time'||key=='update_time'){
            // 	resData[key]=null
            // }
            if (key == 'purchase_price' || key == 'value' || key == 'amount') {
              resData[key] = detailsrow[key]
            }
            delete resData['amount']
            delete resData['company_name']
            delete resData['dept_name']
          }
          resData['create_time'] = null
          resData['update_time'] = null
          resData['att_path'] = this.fileList.join(';')
          resData['cert_path'] = this.fileList2.join(';')
          console.log(resData)
          // Object.assign(resData, { category_name: this.detailsrow.category_name})
          clearTimeout(this.timeout)
          console.log(this.timeout, 'this.timeout===================================')
          this.timeout = setTimeout(() => {
            assetInfo({
              deviceType: resData.device_type,
              dictKey: resData.dict_key,
              id: this.rowId,
              companyId: this.$store.state.user.info.companyId,
              // isInstrument: resData.is_instrument,
              notes: resData.notes,
              amount: resData.amount,
              arriveTime: resData.arrive_time,
              assetSn: resData.asset_sn,
              assetType: resData.asset_type,
              attPath: resData.att_path,
              categoryId: resData.category_id,
              certPath: resData.cert_path,
              charger: resData.charger,
              createBy: resData.create_by,
              dealer: resData.dealer,
              deptId: resData.dept_id,
              factorySn: resData.factory_sn,
              inspectCycle: resData.inspect_cycle,
              inspectResult: resData.inspect_result,
              inspectTime: resData.inspect_time,
              isInspected: resData.is_inspected,
              // itemType: resData.item_type,
              keeper: resData.keeper,
              manufacturer: resData.manufacturer,
              model: resData.model,
              name: resData.name,
              operator: resData.operator,
              permit: resData.permit,
              precisions: resData.precisions,
              purchasePrice: resData.purchase_price.toString(),
              purchaseTime: resData.purchase_time,
              state: resData.state,
              storageCond: resData.storage_cond,
              storageLoc: resData.storage_loc,
              unit: resData.unit,
              value: resData.value.toString(),
            })
              .then((res) => {
                if (res.code == 200) {
                  this.editvisible = false
                  this.$message.success('编辑成功')
                  this.removeList = []
                  this.removeList2 = []
                  this.get_lis()
                } else {
                  this.$message.success(res.msg)
                }
              })
              .catch(() => {
                this.$message.error('系统错误，请稍后再试')
              })
          }, 1000)
        } else {
          return false
        }
      })
    },

    //取消显示
    cancelScrapped() {
      this.is_scrapped = false
    },
    //查看采购信息
    purchaseClick() {
      purchase_apply_asset({ goodId: this.detailsrow.order_id }).then((res) => {
        if (res.code != 200) {
          this.$message.error(res.msg)
          return
        }
        if (res.data == null) {
          this.$message.error('没有相关信息！')
          return
        }
        this.purchaseData = res.data
        purchase_apply_quote(this.detailsrow.order_id).then((quote) => {
          if (quote.code == 200) {
            this.supplierList = quote.data.list
          } else {
            this.$message.error(quote.msg)
          }
        })
        goods_record(this.detailsrow.order_id).then((good) => {
          this.purchspay = good.data.list
        })
        get_process_all({
          procInstId: res.data.business.procInstId,
          name: 'purchase',
          userId: this.$store.getters.userId,
        }).then((process) => {
          var flows = process.data.tasks
          var result = 0
          for (let i = 0, l = flows.length; i < l; i++) {
            if (i + 1 < flows.length) {
              if (flows[i + 1].flag) {
                flows[i]['is_line'] = true
              }
            }
            if (flows[i].result == 3) {
              result = 3
            } else if (flows[i].result == 2) {
              result = 2
            } else if (flows[i].result == 4) {
              result = 4
            }
          }
          flows.forEach((item) => {
            item['result'] = result
          })
          if (result == 3) {
            this.color = '#F56C6C'
          } else if (result == 2) {
            this.color = '#5B8FF9'
          } else if (result == 4) {
            this.color = '#CCCCCC'
          } else {
            this.color = '#5B8FF9'
          }
          this.stpespurchase = flows
        })
        this.is_purchase = true
      })
    },
    cancelPurchase() {
      this.is_purchase = false
    },
  },
}
</script>
<style scoped lang="less">
.dialog {
  display: flex;
  justify-content: space-between;
}

.flex {
  display: flex;
}

.center {
  text-align: center;
  width: 832px;
}

.dialog .dialog_item {
  margin-bottom: 5px;
  width: 220px;
  display: flex;
  justify-content: space-between;
}

.Exhi {
  display: inline-block;
  border: 1px solid black;
  width: 100px;
  text-align: left;
  color: steelblue;
}

.form_item {
  float: left;
  width: 50%;
  min-height: 50px;
  margin-bottom: 10px;
}

.editable-cell {
  position: relative;
}

.editable-cell-input-wrapper,
.editable-cell-text-wrapper {
  padding-right: 24px;
}

.editable-cell-text-wrapper {
  padding: 5px 24px 5px 5px;
}

.editable-cell-icon,
.editable-cell-icon-check {
  position: absolute;
  right: 0;
  width: 20px;
  cursor: pointer;
}

.editable-cell-icon {
  line-height: 18px;
  display: none;
}

.editable-cell-icon-check {
  line-height: 28px;
}

.editable-cell:hover .editable-cell-icon {
  display: inline-block;
}

.editable-cell-icon:hover,
.editable-cell-icon-check:hover {
  color: #108ee9;
}

.editable-add-btn {
  margin-bottom: 8px;
}

.border_a_input {
  border: 1px solid #ddd;
}

.view_path {
  width: 100%;
  float: left;
  cursor: pointer;
}

.resize-table-th {
  position: relative;
}

.table-draggable-handle {
  /* width: 10px !important; */
  height: 100% !important;
  left: auto !important;
  right: -5px;
  cursor: col-resize;
  touch-action: none;
  border: none;
}



.content {
  background-color: #fff;
  padding: 15px;
  border-radius: 10px;
  box-sizing: border-box;
}

.itemForm .ant-form-item-label {
  text-align: left;
}

.itemForm .title {
  padding: 10px 0;
}

.stpe_box {
  width: 100%;
  margin-bottom: 50px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: 50px;

  .stpe_item {
    float: left;
    width: 100%;
    max-width: 300px;
    position: relative;

    .center {
      width: 100%;
      padding: 0 15px;
      box-sizing: border-box;
      max-width: 300px;
      float: left;
      text-align: left;

      .center_val {
        width: 100%;
        max-width: 300px;
        border-radius: 8px;
        float: left;
        padding: 5px 8px;
        box-sizing: border-box;
        background: #eee;
        min-height: 72px;
      }

      .item {
        width: 100%;
        float: left;
      }

      .minItem {
        font-size: 13px;
      }

      .records {
        width: 100%;
        float: left;
        font-size: 13px;
        margin-top: 10px;

        .recordsTop {
          width: 100%;
          float: left;
        }
      }
    }

    .arrow {
      width: 50px;
      float: left;
      font-size: 18px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .stepRound {
      position: absolute;
      left: 50%;
      top: -30px;
      width: 24px;
      height: 24px;
      background: #999;
      border-radius: 50%;
      transform: translateX(-50%);
      z-index: 5;
    }

    .stepLine {
      position: absolute;
      left: 50%;
      top: -20px;
      width: 100%;
      height: 2px;
      background: #eee;
    }
  }
}
</style>



